(window.webpackJsonp=window.webpackJsonp||[]).push([[533],{
/***/"+Z0c":
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=n("4fQY"),o=(n("SMGt"),n("Uolk"),n("WKed"),n("afDP")),s=n("jimv"),c=n("DQGw"),a=n("3xkH"),u=n("6Bdj");
/* harmony import */class d extends i.b{static get styles(){return[o.fb]}static get properties(){return{customer:{type:String},bookmarks:{type:Array},items:{type:Object},startLevel:{type:String},handleBookmarks:{type:Boolean},showMenu:{type:Boolean},showBookmarks:{type:Boolean},width:{type:String},isopen:{type:Boolean},showSearch:{type:Boolean},fullWidth:{type:Boolean},
//private propertiess
_preparedItemsIndexByParent:{attribute:!1},_preparedItemsTree:{attribute:!1},_preparedBookmarks:{attribute:!1},_searchList:{attribute:!1},_pinnedMenu:{attribute:!1},_slicedArray:{attribute:!1},_showFullMenu:{attribute:!1}}}render(){return i.d`
      <div
        id="overlay"
        class="${this.isopen?"":"active"}"
        @click="${()=>c.a.dispatch(Object(a.K)(!Object(u.f)(c.a.getState())))}"
      ></div>
      <div id="mySidenav" class="sidenav ${this.fullWidth?"full-width":""} ${this.isopen?"open":""}">
        <div class="menu-searchbox flex ${this.showSearch?"":"hidden"}">
          <div class="flex-container level">
            <fontawesome-icon
              style="font-size: 28px; cursor: pointer;"
              prefix="fas"
              name="times"
              fixed-width
              @click="${()=>c.a.dispatch(Object(a.K)(!Object(u.f)(c.a.getState())))}"
            ></fontawesome-icon>
            <six-button
              class="btn-sm ${this._pinnedMenu?"btn-default-outline":"btn-default"} pull-right"
              icon="thumbtack"
              @click="${this._handlePinnedMenu}"
            ></six-button>
          </div>
          <div class="search-container">
            <input id="search" type="text" @keyup="${t=>this._menuSearchHandler(t)}" placeholder="${Object(s.a)("COMMON.SEARCH")}" value="" />
          </div>
        </div>
        <div class="bookmarks-entries">
          ${this._showFullMenu?r.f:this._slicedArray.map(t=>i.d`
                  <div class="flex-container item">
                    <div class="icon-container"></div>
                    <div class="title-container">
                      <a href="${t.code}" @click=${e=>this._menuClickHandler(e,t)}> ${this._itemDescription(t)} </a>
                    </div>
                    <div class="icon-container ${this._itemIsBookmark(t)?"color-star":"low-op"}">
                      <fontawesome-icon
                        prefix="fas"
                        name="star"
                        fixed-width
                        @click="${()=>this._bookmarksHandler(t,!this._itemIsBookmark(t))}"
                      ></fontawesome-icon>
                    </div>
                  </div>
                `)}
          ${this._showFullMenu?Object.values(this._searchList).map(t=>i.d`
                    <div class="flex-container item">
                      <div class="icon-container"></div>
                      <div class="title-container">
                        <a href="${t.code}" @click=${e=>this._menuClickHandler(e,t)}> ${this._itemDescription(t)} </a>
                      </div>
                      <div class="icon-container ${this._itemIsBookmark(t)?"color-star":"low-op"}">
                        <fontawesome-icon
                          prefix="fas"
                          name="star"
                          fixed-width
                          @click="${()=>this._bookmarksHandler(t,!this._itemIsBookmark(t))}"
                        ></fontawesome-icon>
                      </div>
                    </div>
                  `):r.f}
          ${this._searchList.length&&this._searchList.length>10?i.d`
                <div class="expandable-menu">
                  <fontawesome-icon
                    prefix="fas"
                    style="cursor: pointer;"
                    name="${this._showFullMenu?"arrow-up":"arrow-down"}"
                    fixed-width
                    @click="${()=>this._showFullMenu=!this._showFullMenu}"
                  ></fontawesome-icon>
                </div>
              `:r.f}
        </div>
        ${Object.keys(this._preparedBookmarks).length?i.d`
              <div class="bookmarks ${this.fullWidth?"full-width":""}">
                <div class="flex-container level">
                  <div class="icon-container"></div>
                  <div class="icon-container">
                    <fontawesome-icon prefix="fas" name="star" fixed-width></fontawesome-icon>
                  </div>

                  <div class="level-title cursor-pointer" @click="${this._collapseBookmarks}">Bookmarks</div>

                  <div class="icon-container">
                    <fontawesome-icon
                      class=".icon-small"
                      prefix="fas"
                      name="${this.showBookmarks?"minus":"plus"}"
                      @click="${this._collapseBookmarks}"
                      fixed-width
                    ></fontawesome-icon>
                  </div>
                </div>
                <div class="bookmarks-entries ${this.showBookmarks?"":"hidden"}">
                  ${Object.values(this._preparedBookmarks).map(t=>i.d`
                      <div class="flex-container item">
                        <div class="icon-container"></div>
                        <div class="icon-container margin">${this._itemIcon(t)}</div>
                        <div class="title-container">
                          <a href="${t.code}" @click=${e=>this._menuClickHandler(e,t)}> ${this._itemDescription(t)} </a>
                        </div>
                        <fontawesome-icon
                          class="moveb low-op-b icon-small"
                          prefix="fas"
                          name="times"
                          fixed-width
                          @click="${()=>this._bookmarksHandler(t,!1)}"
                        ></fontawesome-icon>
                        <fontawesome-icon
                          class="moveb low-op-b icon-small"
                          prefix="fas"
                          name="angle-up"
                          fixed-width
                          @click="${e=>this._bookmarkMoveHandler(e,t,"up")}"
                        ></fontawesome-icon>
                        <fontawesome-icon
                          class="moveb low-op-b icon-small"
                          prefix="fas"
                          name="angle-down"
                          fixed-width
                          @click="${e=>this._bookmarkMoveHandler(e,t,"down")}"
                        ></fontawesome-icon>
                      </div>
                    `)}
                </div>
              </div>
            `:r.f}
        ${this._preparedItemsIndexByParent.root?i.d`
              <div class="menu ${this.fullWidth?"full-width":""}">
                <div class="flex-container level">
                  <div class="icon-container">
                    <fontawesome-icon class=".icon-small" prefix="fas" name="folder-open" fixed-width></fontawesome-icon>
                  </div>

                  <div class="level-title cursor-pointer" @click="${this._collapseMenu}">${this._preparedItemsTree.root.description}</div>

                  <div class="icon-container">
                    <fontawesome-icon
                      class=".icon-small"
                      prefix="fas"
                      name="${this.showMenu?"minus":"plus"}"
                      @click="${this._collapseMenu}"
                      fixed-width
                    ></fontawesome-icon>
                  </div>
                </div>
                <div class="menu-entries ${this.showMenu?"":"hidden"}">
                  ${this._preparedItemsIndexByParent.root.length&&this._preparedItemsIndexByParent.root.map(t=>i.d`
                      <div class="flex-container item ${this.startLevel==t.code?"selected":""}">
                        <div class="icon-container"></div>
                        <div class="icon-container margin">
                          ${this._itemHasChildrens(t)?this.startLevel==t.code?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder-open" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:this._itemIcon(t)}
                        </div>
                        <div class="title-container">
                          <a href="${t.code}" @click=${e=>this._menuClickHandler(e,t)}> ${t.description||t.text} </a>
                        </div>
                        ${this.handleBookmarks&&!this._itemHasChildrens(t)?i.d`
                              <div class="icon-container ${this._itemIsBookmark(t)?"color-star":"low-op"}">
                                <fontawesome-icon
                                  prefix="fas"
                                  name="star"
                                  fixed-width
                                  @click="${()=>this._bookmarksHandler(t,!this._itemIsBookmark(t))}"
                                ></fontawesome-icon>
                              </div>
                            `:r.f}
                        <div class="number-container">
                          ${this._itemHasChildrens(t)?i.d` ${Object.keys(this._preparedItemsIndexByParent[t.code]).length} `:r.f}
                        </div>
                        <div class="icon-container low-op basis-0">
                          ${this._itemHasChildrens(t)?i.d`
                                <fontawesome-icon
                                  @click=${e=>this._menuClickHandler(e,t)}
                                  class=".icon-small"
                                  prefix="fas"
                                  name="${this.startLevel==t.code?"angle-down":"angle-right"}"
                                  fixed-width
                                ></fontawesome-icon>
                              `:r.f}
                        </div>
                      </div>
                      ${this.startLevel==t.code?this._preparedItemsIndexByParent[this.startLevel].length&&this._preparedItemsIndexByParent[this.startLevel].map(t=>i.d`
                              <div class="flex-container item">
                                <div class="icon-container"></div>
                                <div class="icon-container"></div>
                                <div class="icon-container margin">
                                  ${this._itemHasChildrens(t)?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:this._itemIcon(t)}
                                </div>
                                <div class="title-container">
                                  <a href="${t.code}" @click=${e=>this._menuClickHandler(e,t)}> ${t.description||t.text} </a>
                                </div>
                                ${this.handleBookmarks&&!this._itemHasChildrens(t)?i.d`
                                      <div class="icon-container ${this._itemIsBookmark(t)?"color-star":"low-op"}">
                                        <fontawesome-icon
                                          prefix="fas"
                                          name="star"
                                          fixed-width
                                          @click="${()=>this._bookmarksHandler(t,!this._itemIsBookmark(t))}"
                                        ></fontawesome-icon>
                                      </div>
                                    `:r.f}
                                <div class="number-container">
                                  ${this._itemHasChildrens(t)?i.d` ${Object.keys(this._preparedItemsIndexByParent[t.code]).length} `:r.f}
                                </div>
                                <div class="icon-container low-op basis-0">
                                  ${this._itemHasChildrens(t)?i.d`
                                        <fontawesome-icon
                                          @click=${e=>this._menuClickHandler(e,t)}
                                          class=".icon-small"
                                          prefix="fas"
                                          name="angle-right"
                                          fixed-width
                                        ></fontawesome-icon>
                                      `:r.f}
                                </div>
                              </div>
                            `):r.f}
                    `)}
                </div>
              </div>
            `:r.f}
      </div>
    `}constructor(){super(),this.startLevel="root",this._preparedItemsIndexByParent={},this._preparedItemsIndexByObject={},this._preparedBookmarks=[],this._RootItemsOrder=[],this._searchList=[],this._pinnedMenu=!1,this._showFullMenu=!1,this._slicedArray=[]}updated(t){t.has("items")&&this._initMenu(!0),t.has("isopen")&&this.isopen&&this.shadowRoot.querySelector("#search").focus(),t.has("bookmarks")&&this.bookmarks&&this._refreshBookmars()}firstUpdated(){this._initMenu()}_initMenu(t){const e=this._objectClone(this.items);let[n,i,r]=this._prepareItems(e,{},{},"root");this._preparedItemsIndexByParent=i,this._preparedItemsIndexByObject=this._objectClone(r),this._preparedItemsTree={...n,root:{code:0,description:this.customer,icon:"home",show:!0}},t&&this._refreshBookmars()}_bookmarkMoveHandler(t,e,n){let i,r,o,s=[];Object.keys(this._preparedBookmarks).some((t,n)=>{t===e.code&&(r={...e},i=n);let o={...this._preparedBookmarks[t],code:t};s.push(o)}),"down"===n?
// right
i>Object.keys(this._preparedBookmarks).length?o=Object.keys(this._preparedBookmarks).length-1:i>=0&&(o=i+2):(
// left
o=i,i>0&&(o=i-1)),s.splice(i,1,null),s.splice(o,0,r);const c={};s.map(t=>{null!==t&&this._preparedItemsIndexByObject[t.code]&&(c[t.code]=t)}),this._preparedBookmarks=c;const a=Object.values(this._preparedBookmarks).map(t=>t);this.dispatchEvent(new CustomEvent("menuUpdate",{detail:{value:a}}))}_resetBookmarks(){const t=this._objectClone(this._preparedItemsIndexByObject);Object.keys(t).map(e=>{t[e].bookmark=!1}),this._preparedItemsIndexByObject=t}_refreshBookmars(){this._resetBookmarks(),this._prepareBookmarks(),Object.values(this._preparedBookmarks).map(t=>{this._preparedItemsIndexByObject[t.code].bookmark=!0}),this._preparedItemsIndexByObject=this._objectClone(this._preparedItemsIndexByObject)}_prepareBookmarks(){const t=this._objectClone(this.bookmarks),e={};t.map(t=>{this._preparedItemsIndexByObject[t.code]&&(e[t.code]=t,e[t.code].icon=this._preparedItemsIndexByObject[t.code].icon||null)}),this._preparedBookmarks=e}_prepareItems(t={},e={},n={},i,r=null){const o=t;return"root"===i&&(t={},Object.values(JSON.parse(JSON.stringify(o))).map(t=>{t&&t.code&&!this._RootItemsOrder.includes(t.code)&&this._RootItemsOrder.push(t.code)})),Object.values(o).map(o=>{o&&(t[o.code]={code:o.code,description:o.description,icon:o.icon,items:{}},e[i]||(e[i]=[]),e[i].push(o),n[o.code]||(n[o.code]={}),n[o.code]={parentName:i,bookmark:!!this._preparedBookmarks[o.code],icon:o.icon,description:o.description},o.children&&(Object.keys(o.children).map(e=>{const n=o.children[e];t[o.code].items[n.code]=n}),this._prepareItems(t[o.code].items,e,n,o.code,r)))}),[t,e,n]}_menuClickHandler(t,e){if(t.preventDefault(),this._preparedItemsIndexByParent[e.code])return this.startLevel==e.code?void(this.startLevel="root"):void(this.startLevel=e.code);this.dispatchEvent(new CustomEvent("navigate",{detail:{value:e}}))}_menuBackToParentHandler(t){this.startLevel=this._preparedItemsIndexByObject[t].parentName}_bookmarksHandler(t,e){this._preparedItemsIndexByObject[t.code].bookmark=e,this._preparedItemsIndexByObject=this._objectClone(this._preparedItemsIndexByObject),this.dispatchEvent(new CustomEvent(e?"bookmark-add":"bookmark-remove",{detail:{value:t}}))}_itemHasChildrens(t){return this._preparedItemsIndexByParent[t.code]}_itemIsBookmark(t){return this._preparedItemsIndexByObject[t.code].bookmark}_itemDescription(t){return this._preparedItemsIndexByObject[t.code]?this._preparedItemsIndexByObject[t.code].description:""}_itemIcon(t){return t.icon&&"-"!==t.icon&&"--"!==t.icon?t.icon.indexOf("ict:")>-1?i.d` <iron-icon class="icon-small-iron fa-fw" prefix="fas" icon="${t.icon}"></iron-icon> `:t.icon&&"-"!==t.icon&&"--"!==t.icon?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="${t.icon}" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small fa-fw" prefix="fas" name="file"></fontawesome-icon> `}_collapseBookmarks(){this.showBookmarks=!this.showBookmarks}_collapseMenu(){this.showMenu=!this.showMenu}_objectClone(t){return JSON.parse(JSON.stringify(t))}_menuSearchHandler(t){const e=t.target.value;this._showFullMenu=!1,this._slicedArray=[],e?(this._searchList=[],Object.keys(this._preparedItemsIndexByObject).some(t=>{const n=this._preparedItemsIndexByObject[t];n.code=t,n.description.toLowerCase().indexOf(e.toLowerCase())>-1&&!this._itemHasChildrens(n)&&this._searchList.push(n)}),this._slicedArray=this._searchList.slice(0,9),this._slicedArray=[...this._slicedArray]):this._searchList=[]}_handlePinnedMenu(){this._pinnedMenu=!this._pinnedMenu,this.dispatchEvent(new CustomEvent("pinnedMenu",{detail:{value:{pinnedMenu:this._pinnedMenu}}}))}}window.customElements.define("six-menu",d)},
/***/"+aPk":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_PACK_CALLER",r=t=>({type:i,caller:t})
/***/},
/***/"0HYm":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"k",(function(){return i})),
/* harmony export (binding) */n.d(e,"g",(function(){return r})),
/* harmony export (binding) */n.d(e,"B",(function(){return o})),
/* harmony export (binding) */n.d(e,"j",(function(){return s})),
/* harmony export (binding) */n.d(e,"z",(function(){return c})),
/* harmony export (binding) */n.d(e,"v",(function(){return a})),
/* harmony export (binding) */n.d(e,"u",(function(){return u})),
/* harmony export (binding) */n.d(e,"E",(function(){return d})),
/* harmony export (binding) */n.d(e,"w",(function(){return l})),
/* harmony export (binding) */n.d(e,"y",(function(){return E})),
/* harmony export (binding) */n.d(e,"m",(function(){return _})),
/* harmony export (binding) */n.d(e,"l",(function(){return T})),
/* harmony export (binding) */n.d(e,"F",(function(){return f})),
/* harmony export (binding) */n.d(e,"G",(function(){return p})),
/* harmony export (binding) */n.d(e,"d",(function(){return h})),
/* harmony export (binding) */n.d(e,"b",(function(){return S})),
/* harmony export (binding) */n.d(e,"H",(function(){return I})),
/* harmony export (binding) */n.d(e,"A",(function(){return C})),
/* harmony export (binding) */n.d(e,"n",(function(){return m})),
/* unused harmony export DELETE_CUSTOMERDIRTYACCEPTANCE_CUSTOMER_ORDER_ROW */
/* harmony export (binding) */n.d(e,"x",(function(){return R})),
/* harmony export (binding) */n.d(e,"f",(function(){return A})),
/* harmony export (binding) */n.d(e,"h",(function(){return O})),
/* harmony export (binding) */n.d(e,"o",(function(){return D})),
/* harmony export (binding) */n.d(e,"t",(function(){return N})),
/* harmony export (binding) */n.d(e,"q",(function(){return b})),
/* harmony export (binding) */n.d(e,"r",(function(){return L})),
/* harmony export (binding) */n.d(e,"e",(function(){return g})),
/* harmony export (binding) */n.d(e,"a",(function(){return v})),
/* harmony export (binding) */n.d(e,"c",(function(){return y})),
/* harmony export (binding) */n.d(e,"p",(function(){return P})),
/* harmony export (binding) */n.d(e,"s",(function(){return k})),
/* harmony export (binding) */n.d(e,"D",(function(){return w})),
/* harmony export (binding) */n.d(e,"C",(function(){return M})),
/* harmony export (binding) */n.d(e,"i",(function(){return x}));
/* unused harmony export setCustomerDirtyAcceptanceOrderPriority */
/* unused harmony export hideCustomerDirtyAcceptanceOrder */
/* unused harmony export setCustomerDirtyAcceptanceSealedOrderType */
/* unused harmony export setCustomerDirtyAcceptanceKitOrderType */
/* unused harmony export setCustomerDirtyAcceptanceCustomerDestination */
/* unused harmony export setCustomerDirtyAcceptanceCheckinDestination */
/* unused harmony export setCustomerDirtyAcceptanceCustomerOrderNote */
/* unused harmony export setCustomerDirtyAcceptanceCustomerOrderReturnSheet */
/* unused harmony export setCustomerDirtyAcceptanceSerialKitPriority */
/* unused harmony export setCustomerDirtyAcceptanceSerialKitNote */
/* unused harmony export selectCustomerDirtyAcceptanceOrder */
/* unused harmony export setCustomerDirtyAcceptanceSealedProductsList */
/* unused harmony export setCustomerDirtyAcceptanceIncomingMaterialsList */
/* unused harmony export setCustomerDirtyAcceptanceOrderRows */
/* unused harmony export setCustomerDirtyAcceptanceCustomer */
/* unused harmony export setCustomerDirtyAcceptancePrioritiesList */
/* unused harmony export setCustomerDirtyAcceptanceOrdersList */
/* unused harmony export addCustomerDirtyAcceptanceOrder */
/* unused harmony export removeCustomerDirtyAcceptanceOrder */
/* unused harmony export unselectCustomerDirtyAcceptanceOrder */
/* unused harmony export setCustomerDirtyAcceptanceAdditionalInfoVisible */
/* unused harmony export setCustomerDirtyAcceptanceLoanedForm */
/* unused harmony export setCustomerDirtyAcceptanceNewloanedOrder */
/* unused harmony export setCustomerDirtyAcceptanceLoanedSerialKitId */
/* unused harmony export setCustomerDirtyAcceptanceLoanedProductId */
/* unused harmony export setCustomerDirtyAcceptanceLoanedSerialKitImages */
/* unused harmony export setCustomerDirtyAcceptanceActiveLoanedSerialKitImageId */
/* unused harmony export addCustomerDirtyAcceptanceLoanedImage */
/* unused harmony export removeCustomerDirtyAcceptanceLoanedImage */
/* unused harmony export setCustomerDirtyAcceptanceLoanedSerialKitImagesList */
/* unused harmony export setCustomerDirtyAcceptanceSelectedKitForMaintenance */
/* unused harmony export setCustomerDirtyAcceptanceSelectedComponentForMaintenance */
/* unused harmony export setCustomerDirtyAcceptanceContainedContainers */
const i="SET_CUSTOMERDIRTYACCEPTANCE_CUSTOMER_DESTINATION",r="SET_CUSTOMERDIRTYACCEPTANCE_CHECKIN_DESTINATION",o="SET_CUSTOMERDIRTYACCEPTANCE_SEALED_PRODUCTS_LIST",s="SET_CUSTOMERDIRTYACCEPTANCE_CUSTOMER",c="SET_CUSTOMERDIRTYACCEPTANCE_PRIORITIES_LIST",a="SET_CUSTOMERDIRTYACCEPTANCE_ORDERS_LIST",u="SET_CUSTOMERDIRTYACCEPTANCE_ORDER",d="SET_CUSTOMERDIRTYACCEPTANCE_SELECTED_ORDER",l="SET_CUSTOMERDIRTYACCEPTANCE_ORDER_NOTE",E="SET_CUSTOMERDIRTYACCEPTANCE_ORDER_RETURN_SHEET",_="SET_CUSTOMERDIRTYACCEPTANCE_INCOMING_MATERIALS",T="SET_CUSTOMERDIRTYACCEPTANCE_CUSTOMER_ORDER_ROWS",f="SET_CUSTOMERDIRTYACCEPTANCE_SERIAL_KIT_NOTE",p="SET_CUSTOMERDIRTYACCEPTANCE_SERIAL_KIT_PRIORITY",h="REMOVE_CUSTOMERDIRTYACCEPTANCE_ORDER",S="HIDE_CUSTOMERDIRTYACCEPTANCE_ORDER",I="UNSELECT_CUSTOMERDIRTYACCEPTANCE_ORDER",C="SET_CUSTOMERDIRTYACCEPTANCE_SEALED_ORDER_TYPE",m="SET_CUSTOMERDIRTYACCEPTANCE_KIT_ORDER_TYPE",R="SET_CUSTOMERDIRTYACCEPTANCE_ORDER_PRIORITY",A="SET_CUSTOMERDIRTYACCEPTANCE_ADDITIONAL_INFO_VISIBLE",O="SET_CUSTOMERDIRTYACCEPTANCE_CODE_READ",D="SET_CUSTOMERDIRTYACCEPTANCE_LOANED_FORM_FIELD_CHANGED",N="SET_CUSTOMERDIRTYACCEPTANCE_NEW_LOANED_ORDER",b="SET_CUSTOMERDIRTYACCEPTANCE_LOANED_SERIAL_KIT_ID",L="SET_LOANED_SERIAL_KIT_IMAGE",g="SET_CUSTOMERDIRTYACCEPTANCE_ACTIVE_LOANED_SERIAL_KIT_IMAGE_ID",v="ADD_CUSTOMERDIRTYACCEPTANCE_LOANED_IMAGE",y="REMOVE_CUSTOMERDIRTYACCEPTANCE_LOANED_IMAGE",P="SET_CUSTOMERDIRTYACCEPTANCE_LOANED_PRODUCT_KIT_ID",k="SET_CUSTOMERDIRTYACCEPTANCE_LOANED_SERIAL_KIT_IMAGES_LIST",w="SET_CUSTOMERDIRTYACCEPTANCE_SELECTED_KIT_FOR_MAINTENANCE",M="SET_CUSTOMERDIRTYACCEPTANCE_SELECTED_COMPONENT_FOR_MAINTENANCE",x="SET_CUSTOMERDIRTYACCEPTANCE_CONTAINED_CONTAINERS"},
/***/"3xkH":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"w",(function(){return i})),
/* harmony export (binding) */n.d(e,"v",(function(){return r})),
/* harmony export (binding) */n.d(e,"u",(function(){return o})),
/* harmony export (binding) */n.d(e,"b",(function(){return s})),
/* harmony export (binding) */n.d(e,"a",(function(){return c})),
/* harmony export (binding) */n.d(e,"p",(function(){return a})),
/* harmony export (binding) */n.d(e,"e",(function(){return u})),
/* harmony export (binding) */n.d(e,"s",(function(){return d})),
/* harmony export (binding) */n.d(e,"t",(function(){return l})),
/* harmony export (binding) */n.d(e,"n",(function(){return E})),
/* harmony export (binding) */n.d(e,"o",(function(){return _})),
/* harmony export (binding) */n.d(e,"d",(function(){return T})),
/* harmony export (binding) */n.d(e,"r",(function(){return f})),
/* harmony export (binding) */n.d(e,"h",(function(){return p})),
/* harmony export (binding) */n.d(e,"q",(function(){return h})),
/* harmony export (binding) */n.d(e,"f",(function(){return S})),
/* harmony export (binding) */n.d(e,"g",(function(){return I})),
/* harmony export (binding) */n.d(e,"k",(function(){return C})),
/* harmony export (binding) */n.d(e,"j",(function(){return m})),
/* harmony export (binding) */n.d(e,"l",(function(){return R})),
/* harmony export (binding) */n.d(e,"c",(function(){return A})),
/* harmony export (binding) */n.d(e,"i",(function(){return O})),
/* harmony export (binding) */n.d(e,"m",(function(){return D})),
/* unused harmony export showSnackbar */
/* harmony export (binding) */n.d(e,"K",(function(){return b})),
/* harmony export (binding) */n.d(e,"L",(function(){return L})),
/* harmony export (binding) */n.d(e,"y",(function(){return g})),
/* unused harmony export setPriorityLevels */
/* harmony export (binding) */n.d(e,"I",(function(){return v})),
/* harmony export (binding) */n.d(e,"J",(function(){return y})),
/* harmony export (binding) */n.d(e,"G",(function(){return P})),
/* harmony export (binding) */n.d(e,"H",(function(){return k})),
/* unused harmony export setMinQuantityIsNeededForCompliance */
/* unused harmony export setCanEnterPackagingIfContainerIsBeingWashed */
/* unused harmony export setCustomerDestinations */
/* unused harmony export setOperativeAreaList */
/* unused harmony export setCurrentOperativeArea */
/* harmony export (binding) */n.d(e,"z",(function(){return w})),
/* harmony export (binding) */n.d(e,"D",(function(){return M})),
/* harmony export (binding) */n.d(e,"C",(function(){return x})),
/* harmony export (binding) */n.d(e,"E",(function(){return G})),
/* harmony export (binding) */n.d(e,"x",(function(){return K})),
/* harmony export (binding) */n.d(e,"B",(function(){return U})),
/* harmony export (binding) */n.d(e,"F",(function(){return B})),
/* harmony export (binding) */n.d(e,"A",(function(){return H}));const i="UPDATE_PAGE",r="UPDATE_OFFLINE",o="UPDATE_DRAWER_STATE",s="OPEN_SNACKBAR",c="CLOSE_SNACKBAR",a="SET_MIN_QUANTITY_NEEDED_COMPLIANCE",u="SET_CODE_READ",d="SET_PRIORITY_LEVELS",l="SET_PRODUCT_DEFAULT_TYPES",E="SET_MENU_INDEX",_="SET_MENU_ITEMS",T="SET_CAN_ENTER_PACKAGING_IF_CONTAINER_IS_BEING_WASHED",f="SET_PINNED_MENU",p="SET_CUSTOMER_DESTINATIONS",h="SET_OPERATIVE_AREA_LIST",S="SET_CURRENT_OPERATIVE_AREA",I="SET_CURRENT_WEBSOCKET_STATUS",C="SET_JASPER_PARENT_FOLDER_URI",m="SET_JASPER_CONTEXT_PATH",R="SET_JASPER_REPORT_ALLOWED",A="SET_AGREEMENT_ITEM_PARENT",O="SET_GLOBAL_SPINNER",D="SET_JASPER_USER_PASSWORD";let N;const b=t=>({type:o,opened:t}),L=t=>(e,n)=>{
// Show the snackbar only if offline status changes.
t!==n().app.offline&&e(t=>{t({type:s}),window.clearTimeout(N),N=window.setTimeout(()=>t({type:c}),3e3)}),e({type:r,offline:t})},g=t=>({type:u,codeRead:null!=t?t:""}),v=t=>({type:f,pinnedMenu:t}),y=t=>({type:l,productDefaultTypes:t}),P=t=>({type:E,menuIndex:t}),k=t=>({type:_,menuItems:t}),w=t=>({type:I,websocketStatus:t}),M=t=>({type:C,jasperParentFolderUri:t}),x=t=>({type:m,jasperContextPath:t}),G=t=>({type:R,jasperReportAllowed:t}),K=t=>({type:A,agreementItemParent:t}),U=t=>({type:O,globalSpinner:t}),B=t=>({type:D,jasperPassword:t}),H=t=>`<div style="max-width: 100%; max-height: 600px; width: auto; height: auto;"><img style="height: 90vh; width: auto;" src="/minio/${t}"/></div>`},
/***/5786:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o})),
/* harmony export (binding) */n.d(e,"d",(function(){return s}));const i="SET_COMPONENT_LIST",r="SET_COMPONENT_LIST_FULL",o=t=>({type:i,componentList:t}),s=t=>({type:r,componentListFull:t})},
/***/"5NAI":
/***/function(t,e,n){"use strict";
/* unused harmony export SET_XLSIMPORT_PAGE */
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"c",(function(){return r})),
/* harmony export (binding) */n.d(e,"a",(function(){return o})),
/* harmony export (binding) */n.d(e,"b",(function(){return s})),
/* harmony export (binding) */n.d(e,"f",(function(){return c})),
/* harmony export (binding) */n.d(e,"i",(function(){return a})),
/* harmony export (binding) */n.d(e,"h",(function(){return u})),
/* harmony export (binding) */n.d(e,"g",(function(){return d})),
/* harmony export (binding) */n.d(e,"e",(function(){return l}));const i="SET_XLSIMPORT_TOTAL_ROWS",r="SET_XLSIMPORT_SUCCESS_ROWS",o="SET_XLSIMPORT_ERROR_ROWS",s="SET_XLSIMPORT_REMAINING_ROWS",c=t=>({type:"SET_XLSIMPORT_PAGE",xlsImportPage:t}),a=t=>({type:i,xlsTotalRows:t}),u=t=>({type:r,xlsSuccessRows:t}),d=t=>({type:s,xlsRemainingRows:t}),l=t=>({type:o,xlsErrorRows:t})},
/***/"7ZXM":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_ACTIVE_GRID_FILTERS",r=t=>({type:i,filters:t})},
/***/"7eJ4":
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=(n("KR5w"),n("SMGt"),n("4fQY")),o=n("afDP");
/* harmony import */
// This element is *not* connected to the Redux store.
class s extends i.b{static get styles(){return[o.D,o.xb]}static get properties(){return{
// Label displayed on title
label:{type:String},
// Icon class
icon:{type:String},class:{type:String},
// "fas" or similar, for fontawesome icons
prefix:{type:String},color:{type:String},useIct:{type:Boolean},useFontawesome:{type:Boolean}}}constructor(){super(),this.prefix="fas",this.set="fa"}render(){return i.d`
      <h3 class="${this.class}" style="${this.color?"color: "+this.color:""}">
        ${this.useFontawesome?i.d` <fontawesome-icon prefix="${this.prefix}" name="${this.icon}" fixed-width></fontawesome-icon> `:r.f}
        ${this.useIct?i.d` <iron-icon icon="ict:${this.icon}"></iron-icon> `:r.f} ${this.label||r.f}
      </h3>
    `}}window.customElements.define("six-title",s)},
/***/"8JIg":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o}));
/* unused harmony export setSelectedKitsAction */
/* unused harmony export setControlDetailKit */
/* unused harmony export subsituteSterControlKitAction */
const i="SET_CONTROL_SELECTED_KITS",r="CONTROL_SET_DETAIL_KIT",o="SUBSTITUTE_STER_CONTROL_KIT"},
/***/"8rHI":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"c",(function(){return r})),
/* harmony export (binding) */n.d(e,"a",(function(){return o})),
/* harmony export (binding) */n.d(e,"e",(function(){return s})),
/* unused harmony export setProdorderSelectedOrder */
/* harmony export (binding) */n.d(e,"d",(function(){return c}));const i="SET_PRODORDER_LIST",r="SET_PRODORDER_SELECTED_ORDER",o="SET_PRODORDER_ACTIVE_PAGE",s=t=>({type:i,prodorderList:t}),c=t=>({type:o,page:t})},
/***/AUg4:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r}));
/* unused harmony export setWarehouseHandlingWarehouseList */
/* unused harmony export setWarehouseHandlingSelectedRow */
const i="SET_WAREHOUSEHANDLING_WAREHOUSE_LIST",r="SET_WAREHOUSEHANDLING_SELECTED_PRODUCT"},
/***/CNe1:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return r}));
/* harmony import */var i=n("zbnX");class r extends i.a{
// Only render this page if it's actually visible.
shouldUpdate(){return this.active}static get properties(){return{active:{type:Boolean},location:{type:String}}}connectedCallback(){super.connectedCallback(),this.setAttribute("active","")}disconnectedCallback(){super.disconnectedCallback(),this.removeAttribute("active")}}
/***/},
/***/"Cq7+":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"p",(function(){return i})),
/* harmony export (binding) */n.d(e,"m",(function(){return r})),
/* harmony export (binding) */n.d(e,"G",(function(){return o})),
/* harmony export (binding) */n.d(e,"o",(function(){return s})),
/* harmony export (binding) */n.d(e,"E",(function(){return c})),
/* harmony export (binding) */n.d(e,"C",(function(){return a})),
/* harmony export (binding) */n.d(e,"a",(function(){return u})),
/* harmony export (binding) */n.d(e,"h",(function(){return d})),
/* harmony export (binding) */n.d(e,"q",(function(){return l})),
/* harmony export (binding) */n.d(e,"r",(function(){return E})),
/* harmony export (binding) */n.d(e,"v",(function(){return _})),
/* harmony export (binding) */n.d(e,"s",(function(){return T})),
/* harmony export (binding) */n.d(e,"H",(function(){return f})),
/* harmony export (binding) */n.d(e,"I",(function(){return p})),
/* harmony export (binding) */n.d(e,"f",(function(){return h})),
/* harmony export (binding) */n.d(e,"c",(function(){return S})),
/* harmony export (binding) */n.d(e,"g",(function(){return I})),
/* harmony export (binding) */n.d(e,"F",(function(){return C})),
/* harmony export (binding) */n.d(e,"w",(function(){return m})),
/* unused harmony export DELETE_PREORDER_CUSTOMER_ORDER_ROW */
/* harmony export (binding) */n.d(e,"D",(function(){return R})),
/* harmony export (binding) */n.d(e,"l",(function(){return A})),
/* harmony export (binding) */n.d(e,"n",(function(){return O})),
/* harmony export (binding) */n.d(e,"d",(function(){return D})),
/* harmony export (binding) */n.d(e,"B",(function(){return N})),
/* harmony export (binding) */n.d(e,"y",(function(){return b})),
/* harmony export (binding) */n.d(e,"z",(function(){return L})),
/* harmony export (binding) */n.d(e,"k",(function(){return g})),
/* harmony export (binding) */n.d(e,"b",(function(){return v})),
/* harmony export (binding) */n.d(e,"e",(function(){return y})),
/* harmony export (binding) */n.d(e,"x",(function(){return P})),
/* harmony export (binding) */n.d(e,"A",(function(){return k})),
/* harmony export (binding) */n.d(e,"u",(function(){return w})),
/* harmony export (binding) */n.d(e,"t",(function(){return M})),
/* harmony export (binding) */n.d(e,"i",(function(){return x})),
/* harmony export (binding) */n.d(e,"K",(function(){return G})),
/* harmony export (binding) */n.d(e,"J",(function(){return K})),
/* harmony export (binding) */n.d(e,"j",(function(){return U})),
/* harmony export (binding) */n.d(e,"L",(function(){return B}));
/* unused harmony export setOrderPriority */
/* unused harmony export hideOrder */
/* unused harmony export setSealedOrderType */
/* unused harmony export setKitOrderType */
/* unused harmony export setCustomerDestination */
/* unused harmony export setCheckinDestination */
/* unused harmony export setCustomerOrderNote */
/* unused harmony export setCustomerOrderReturnSheet */
/* unused harmony export setSerialKitPriority */
/* unused harmony export setSerialKitNote */
/* unused harmony export selectOrder */
/* unused harmony export setSealedProductsList */
/* unused harmony export setIncomingMaterialsList */
/* unused harmony export setOrderRows */
/* unused harmony export setCustomer */
/* unused harmony export setPrioritiesList */
/* unused harmony export setOrdersList */
/* unused harmony export addOrder */
/* unused harmony export removeOrder */
/* unused harmony export unselectOrder */
/* unused harmony export setAdditionalInfoVisible */
/* unused harmony export setLoanedForm */
/* unused harmony export setNewloanedOrder */
/* unused harmony export setLoanedSerialKitId */
/* unused harmony export setLoanedProductId */
/* unused harmony export setLoanedSerialKitImages */
/* unused harmony export setActiveLoanedSerialKitImageId */
/* unused harmony export addLoanedImage */
/* unused harmony export removeLoanedImage */
/* unused harmony export setLoanedSerialKitImagesList */
/* unused harmony export setDirtyAcceptanceSelectedKitForMaintenance */
/* unused harmony export setDirtyAcceptanceSelectedComponentForMaintenance */
/* unused harmony export setPreOrderAcceptanceManualWashingIsAllowed */
/* unused harmony export setPreOrderPreWashingIsAllowed */
/* unused harmony export setPreOrderPreWashingGroupCode */
/* unused harmony export setManualWashingObjects */
/* unused harmony export setPreWashingObjects */
const i="SET_CUSTOMER_PREORDER_DESTINATION",r="SET_PREORDER_CHECKIN_DESTINATION",o="SET_PREORDER_SEALED_PRODUCTS_LIST",s="SET_PREORDER_CUSTOMER",c="SET_PREORDER_PRIORITIES_LIST",a="SET_PREORDER_ORDERS_LIST",u="ADD_PREORDER_ORDER",d="SELECT_PREORDER_ORDER",l="SET_PREORDER_CUSTOMER_ORDER_NOTE",E="SET_PREORDER_CUSTOMER_ORDER_RETURN_SHEET",_="SET_PREORDER_INCOMING_MATERIALS",T="SET_PREORDER_CUSTOMER_ORDER_ROWS",f="SET_PREORDER_SERIAL_KIT_NOTE",p="SET_PREORDER_SERIAL_KIT_PRIORITY",h="PREORDER_REMOVE_ORDER",S="PREORDER_HIDE_ORDER",I="PREORDER_UNSELECT_ORDER",C="SET_PREORDER_SEALED_ORDER_TYPE",m="SET_PREORDER_KIT_ORDER_TYPE",R="SET_PREORDER_ORDER_PRIORITY",A="SET_PREORDER_ADDITIONAL_INFO_VISIBLE",O="SET_PREORDER_CODE_READ",D="PREORDER_LOANED_FORM_FIELD_CHANGED",N="SET_PREORDER_NEW_LOANED_ORDER",b="PREORDER_SET_LOANED_SERIAL_KIT_ID",L="SET_PREORDER_LOANED_SERIAL_KIT_IMAGE",g="SET_PREORDER_ACTIVE_LOANED_SERIAL_KIT_IMAGE_ID",v="PREORDER_ADD_LOANED_IMAGE",y="PREORDER_REMOVE_LOANED_IMAGE",P="SET_PREORDER_LOANED_PRODUCT_KIT_ID",k="SET_PREORDER_LOANED_SERIAL_KIT_IMAGES_LIST",w="SET_PREORDER_DIRTYACCEPTANCE_SELECTED_KIT_FOR_MAINTENANCE",M="SET_PREORDER_DIRTYACCEPTANCE_SELECTED_COMPONENT_FOR_MAINTENANCE",x="SET_MANUAL_WASHING_IS_ALLOWED",G="SET_PRE_WASHING_IS_ALLOWED",K="SET_PRE_WASHING_GROUP_CODE",U="SET_MANUAL_WASHING_OBJECTS",B="SET_PRE_WASHING_OBJECTS"},
/***/Cvaf:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"d",(function(){return o})),
/* harmony export (binding) */n.d(e,"c",(function(){return s}));const i="SET_ROW_DETAIL",r="SET_CALLER",o=t=>({type:i,row:t}),s=t=>({type:r,caller:t})
/***/},
/***/F3b1:
/***/function(t,e,n){"use strict";n.r(e);
/* harmony import */n("Cndk");
/* harmony import */var i=n("Q1Ke"),r=n("jimv"),o=n("vcFs");if(
/* Import WebpackApp */
// Redux assumes `process.env.NODE_ENV` exists in the ES module build.
// https://github.com/reactjs/redux/issues/2907
window.process={env:{NODE_ENV:"production"}},"serviceWorker"in navigator&&!0===o.d){const t=new i.a("/sw.js");//creato a build-time da webpack
t.addEventListener("waiting",()=>{let e,n;const i=new Promise((t,i)=>{e=t,n=i}),o={type:"info",title:Object(r.a)("COMMON.UPDATE"),message:Object(r.a)("COMMON.UPDATE_AVAILABLE"),position:"top-right",duration:0,okButton:!0,cancelButton:!1,okButtonText:Object(r.a)("COMMON.DO_UPDATE"),cancelButtonText:void 0};document.dispatchEvent(new CustomEvent("new-sx-message",{detail:{message:o,promise:{resolve:e,reject:n}}})),i.then(()=>{t.addEventListener("controlling",()=>{let t=document.createElement("form");t.setAttribute("action",window.location.href),t.setAttribute("method","GET"),document.body.appendChild(t),t.submit()}),t.messageSW({type:"SKIP_WAITING"})})}),t.register().then(t=>{console.log("SW registered with scope:",t.scope)}).catch(t=>{console.error("Registration failed:",t)})}
/***/},
/***/GGEq:
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=(n("WKed"),n("+/1h"),n("SMGt"),n("afDP")),o=n("4fQY"),s=n("N+pe"),c=n("jimv"),a=n("/84T");
/* harmony import */
//https://www.webcomponents.org/element/@polymer/paper-dialog/elements/paper-dialog
class u extends i.b{static get styles(){return[r.i,r.gb]}render(){return i.d`
      <paper-dialog
        id="${this._id}"
        class="${Object(a.a)({sizeSm:"sm"==this.size,sizeMd:"md"==this.size,sizeLg:"lg"==this.size})}"
        @opened-changed="${this._openChanged}"
        ?modal="${this.modal}"
        ?with-backdrop="${!this.modal}"
        ?opened="${this.displayOpen}"
      >
        ${this.modal?o.f:i.d`
              <div style="margin:0px; padding:0px;">
                <fontawesome-icon
                  @click="${this.close}"
                  title="${Object(c.a)("COMMON.CLOSE")}"
                  style="float: right;margin-right: 10px;margin-top: 10px; cursor:pointer"
                  name="times"
                  prefix="fas"
                  fixed-width
                ></fontawesome-icon>
              </div>
            `}
        <div class="dialog-content">
          <div class="col-md 12">
            ${this.title?i.d` <h2>${this.title}</h2> `:o.f} ${this.text?i.d` <span>${this.text}</span> `:o.f}
            <slot name="content"> </slot>
          </div>
        </div>

        <div class="dialog-footer clearfix">
          <slot name="footer">
            <div class="pull-right" style="margin-top:2%">
              <six-button class="btn-sm btn-danger" icon="window-close" label="${Object(c.a)("COMMON.CANCEL")}" @click="${this._onCancel}"></six-button>
              <six-button class="btn-sm btn-success" icon="check-square" label="${Object(c.a)("COMMON.CONFIRM")}" @click="${this._onConfirm}"></six-button>
            </div>
          </slot>
        </div>
      </paper-dialog>
    `}
/* ************** START: STRUTTURA BASE PAGINA ************** */static get properties(){return{modal:{type:Boolean},
//implies no-cancel-on-outside-click, no-cancel-on-esc-key and with-backdrop
text:{type:String},title:{type:String},size:{type:String},
//sm, md, lg
displayOpen:{type:Boolean},noAutoclose:{type:Boolean},
//disable auto close modal on confirm/cancel
open:{attribute:!1},
//open modal
close:{attribute:!1},
//close modal
isOpen:{attribute:!1}};
/* slots available for replacement: 'footer', 'content' */}get isOpen(){return this._dialog&&this._dialog.opened||!1}set isOpen(t){//cannot set
}constructor(){super(),this._id=Object(s.l)()}firstUpdated(){this._dialog=this.shadowRoot.querySelector("#"+this._id)}
/* ************** END: STRUTTURA BASE PAGINA ************** */open(){this._dialog.open()}close(){this._dialog.close()}_onConfirm(){this.dispatchEvent(new CustomEvent("confirm",{detail:{value:{}}})),this.noAutoclose||this.close()}_onCancel(){this.dispatchEvent(new CustomEvent("cancel",{detail:{value:{}}})),this.noAutoclose||this.close()}_openChanged(t){t.stopPropagation(),this.dispatchEvent(new CustomEvent("opened-changed",{detail:{value:{opened:this.isOpen}}}))}}window.customElements.define("six-modal",u)},
/***/Gj0I:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"i",(function(){return a})),
/* unused harmony export setCustomerorderSelectedOrder */
/* harmony export (binding) */n.d(e,"g",(function(){return u})),
/* harmony export (binding) */n.d(e,"f",(function(){return d})),
/* harmony export (binding) */n.d(e,"h",(function(){return l}));const i="SET_CUSTOMERORDER_LIST",r="SET_CUSTOMERORDER_SELECTED_ORDER",o="SET_CUSTOMERORDER_ACTIVE_PAGE",s="SET_CUSTOMERORDER_ACTIVE_GRID_FILTERS",c="SET_CUSTOMERORDER_CALLER",a=t=>({type:i,customerorderList:t}),u=t=>({type:o,page:t}),d=t=>({type:s,filters:t}),l=t=>({type:c,caller:t})},
/***/H2oS:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"d",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"c",(function(){return s})),
/* harmony export (binding) */n.d(e,"f",(function(){return c})),
/* harmony export (binding) */n.d(e,"e",(function(){return a})),
/* harmony export (binding) */n.d(e,"l",(function(){return u})),
/* harmony export (binding) */n.d(e,"m",(function(){return d})),
/* harmony export (binding) */n.d(e,"g",(function(){return l})),
/* harmony export (binding) */n.d(e,"h",(function(){return E})),
/* harmony export (binding) */n.d(e,"n",(function(){return _})),
/* harmony export (binding) */n.d(e,"k",(function(){return T})),
/* harmony export (binding) */n.d(e,"i",(function(){return f})),
/* harmony export (binding) */n.d(e,"o",(function(){return p})),
/* harmony export (binding) */n.d(e,"j",(function(){return h})),
/* harmony export (binding) */n.d(e,"q",(function(){return S})),
/* harmony export (binding) */n.d(e,"p",(function(){return I})),
/* harmony export (binding) */n.d(e,"r",(function(){return C})),
/* harmony export (binding) */n.d(e,"u",(function(){return m})),
/* harmony export (binding) */n.d(e,"s",(function(){return R})),
/* harmony export (binding) */n.d(e,"t",(function(){return A})),
/* harmony export (binding) */n.d(e,"w",(function(){return O})),
/* harmony export (binding) */n.d(e,"v",(function(){return D})),
/* harmony export (binding) */n.d(e,"E",(function(){return N})),
/* harmony export (binding) */n.d(e,"H",(function(){return b})),
/* harmony export (binding) */n.d(e,"F",(function(){return L})),
/* harmony export (binding) */n.d(e,"x",(function(){return g})),
/* harmony export (binding) */n.d(e,"y",(function(){return v})),
/* harmony export (binding) */n.d(e,"G",(function(){return y})),
/* harmony export (binding) */n.d(e,"D",(function(){return P})),
/* harmony export (binding) */n.d(e,"B",(function(){return k})),
/* harmony export (binding) */n.d(e,"C",(function(){return w})),
/* harmony export (binding) */n.d(e,"z",(function(){return M})),
/* harmony export (binding) */n.d(e,"A",(function(){return x}));const i="INIT_AUTOLOADING_DETAILSTEP",r="RESTORE_AUTOLOADING_DETAILSTEP",o="NEXT_AUTLOADING_DETAILSTEP",s="PREVIOUS_AUTOLOADING_DETAILSTEP",c="SET_AUTOLOADING_DETAILSTEP",a="SET_AUTOLOADING_CARTS",u="SET_AUTOLOADING_SELECTEDCART",d="SET_AUTOLOADING_SELECTEDEQUIPMENT",l="SET_AUTOLOADING_ELEMENTSLOADED",E="SET_AUTOLOADING_ELEMENTSTOLOADING",_="SET_AUTOLOADING_SELECTEDPRODUCTIVEREASON",T="SET_AUTOLOADING_PRODUCTIVEREASONS",f="SET_AUTOLOADING_EQUIPMENTS",p="SET_AUTOLOADING_SELECTED_PROD_ORDER_ID",h="SET_AUTOLOADING_ERROR",S="SET_AUTO_SHOW_EQUIPMENT_CONFIRM_DIALOG",I="SET_AUTOLOADING_TOGGLE_RELOAD_DATA",C=()=>({type:i}),m=()=>({type:r}),R=()=>({type:o}),A=()=>({type:s}),O=t=>({type:c,step:t}),D=t=>({type:a,carts:t}),N=t=>({type:u,cart:t}),b=t=>({type:p,selectedProdOrderId:t}),L=t=>({type:d,equipment:t}),g=t=>({type:l,elementsLoaded:t}),v=t=>({type:E,elementsToLoading:t}),y=t=>({type:_,productiveReason:t}),P=t=>({type:T,reasons:t}),k=t=>({type:f,equipments:t}),w=t=>({type:h,error:!0===t}),M=t=>({type:S,showEquipmentConfirmDialog:!0===t}),x=()=>({type:I})},
/***/IIUQ:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"f",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o})),
/* harmony export (binding) */n.d(e,"d",(function(){return s})),
/* harmony export (binding) */n.d(e,"e",(function(){return c})),
/* harmony export (binding) */n.d(e,"b",(function(){return a})),
/* harmony export (binding) */n.d(e,"g",(function(){return u})),
/* harmony export (binding) */n.d(e,"j",(function(){return d})),
/* unused harmony export setCrudEntitySchemaColumns */
/* unused harmony export setCrudElementsList */
/* harmony export (binding) */n.d(e,"i",(function(){return l})),
/* harmony export (binding) */n.d(e,"h",(function(){return E}));
/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
const i="SET_CRUD_ENTITY",r="SET_CRUD_SUB_ENTITY",o="SET_CRUD_ENTITY_SCHEMA_COLUMNS",s="SET_CRUD_LIST_ELEMENTS",c="SET_CRUD_SELECTED_ELEMENT",a="SET_CRUD_ENTITY_HAS_BEEN_CHANGED",u=t=>({type:i,crudEntity:t}),d=t=>({type:r,crudSubEntity:t}),l=t=>({type:c,crudSelectedElement:t}),E=t=>({type:a,crudEntityChangedAt:t})},
/***/IzAr:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* unused harmony export setInventoryId */
/* harmony export (binding) */n.d(e,"c",(function(){return o}));const i="SET_INVENTORY_ID",r="SET_INVENTORY_CALLER",o=t=>({type:r,caller:t})},
/***/JqkD:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_ACTIVE_FILTERS",r=t=>({type:i,filters:t})
/***/},
/***/"LAU/":
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=n("4fQY"),o=(n("GGEq"),n("7eJ4"),n("afDP"));
/* harmony import */class s extends i.b{static get styles(){return[o.hb]}static get properties(){return{showLoading:{type:Boolean},asModal:{type:Boolean},small:{type:Boolean}}}constructor(){super(),this._hidingPromises=[]}render(){return i.d` ${this.showLoading?i.d` <span class="loader"></span> `:r.f}`}show(t){if(this.showLoading=!0,t)return this._hidingPromises.push(t),t.finally(()=>{this._hidingPromises.pop(),this.hide()}),t}hide(){0===this._hidingPromises.length&&(this.showLoading=!1)}}window.customElements.define("six-new-spinner",s)},
/***/LBkZ:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c}));
/* unused harmony export setReturnddtMultipleRows */
/* unused harmony export setReturnddtMultipleSelectedDdt */
/* unused harmony export setReturnddtMultipleDdtCreatedFlag */
/* unused harmony export setReturnddtMultipleCreatedDdtList */
/* unused harmony export setReturnddtMultipleDdtDetailFlag */
const i="SET_RETURNDDTMULTIPLE_ROWS",r="SET_RETURNDDTMULTIPLE_SELECTED_DDT",o="SET_RETURNDDTMULTIPLE_DDT_CREATED_FLAG",s="SET_RETURNDDTMULTIPLE_DDT_CREATED_CREATED_DDT_LIST",c="SET_RETURNDDTMULTIPLE_DDT_DETAIL_FLAG"},
/***/Lt5T:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"e",(function(){return i})),
/* harmony export (binding) */n.d(e,"f",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"d",(function(){return a})),
/* harmony export (binding) */n.d(e,"j",(function(){return u})),
/* unused harmony export setCleanAcceptanceSelectedOrder */
/* harmony export (binding) */n.d(e,"g",(function(){return d})),
/* unused harmony export setCleanAcceptanceActiveGridFilters */
/* harmony export (binding) */n.d(e,"h",(function(){return l})),
/* harmony export (binding) */n.d(e,"i",(function(){return E}));const i="SET_CLEAN_ACCEPTANCE_LIST",r="SET_CLEAN_ACCEPTANCE_SELECTED_ORDER",o="SET_CLEAN_ACCEPTANCE_ACTIVE_PAGE",s="SET_CLEAN_ACCEPTANCE_ACTIVE_GRID_FILTERS",c="SET_CLEAN_ACCEPTANCE_CALLER",a="SET_CLEAN_ACCEPTANCE_ELEMENTS_TO_RECOVER",u=t=>({type:i,cleanAcceptanceList:t}),d=t=>({type:o,page:t}),l=t=>({type:c,caller:t}),E=t=>({type:a,elements:t})},
/***/"N+pe":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"g",(function(){return a})),
/* harmony export (binding) */n.d(e,"s",(function(){return u})),
/* harmony export (binding) */n.d(e,"c",(function(){return d})),
/* unused harmony export dateTmzHTML */
/* harmony export (binding) */n.d(e,"e",(function(){return l})),
/* unused harmony export getPriorityColorStyleHTML */
/* harmony export (binding) */n.d(e,"b",(function(){return E})),
/* unused harmony export dateTmz */
/* harmony export (binding) */n.d(e,"d",(function(){return _})),
/* harmony export (binding) */n.d(e,"n",(function(){return T})),
/* harmony export (binding) */n.d(e,"i",(function(){return f})),
/* harmony export (binding) */n.d(e,"t",(function(){return p})),
/* harmony export (binding) */n.d(e,"o",(function(){return h})),
/* harmony export (binding) */n.d(e,"p",(function(){return S})),
/* harmony export (binding) */n.d(e,"m",(function(){return I})),
/* harmony export (binding) */n.d(e,"k",(function(){return C})),
/* unused harmony export getSerialKitPriorityLevel */
/* unused harmony export getPriorityLevelsAsMap */
/* harmony export (binding) */n.d(e,"j",(function(){return m})),
/* harmony export (binding) */n.d(e,"l",(function(){return R})),
/* harmony export (binding) */n.d(e,"r",(function(){return A})),
/* harmony export (binding) */n.d(e,"q",(function(){return O})),
/* unused harmony export playInfoSound */
/* harmony export (binding) */n.d(e,"f",(function(){return D})),
/* harmony export (binding) */n.d(e,"h",(function(){return N})),
/* unused harmony export objectIsNotEmpty */
/* harmony export (binding) */n.d(e,"a",(function(){return b}));
/* unused harmony export getPayloadGqlFilter */
/* harmony import */var i=n("4fQY"),r=n("jimv"),o=n("72OT"),s=n.n(o);
/* harmony import */n("OcfT");
//altrimenti non vengono inseriti nel bundle
const c={priorityValues:{0:"PR_STANDARD",10:"PR_PRIORITY",20:"PR_URGENT",30:"PR_LIFESAVER"},priorityThreshold:20,priorityLevels:{PR_STANDARD:{level:0,description:"Standard",production_time:604800,alert_time:518400,bg_color:"rgba(255,206,84,0.4)"},PR_PRIORITY:{level:10,description:"Prioritario",production_time:604800,alert_time:518400,bg_color:"rgba(245, 161, 4, 0.69);"},PR_URGENT:{level:20,description:"Urgente",production_time:604800,alert_time:518400,bg_color:"rgba(237,85,101,0.4)"},PR_LIFESAVER:{level:30,description:"Salvavita",production_time:604800,alert_time:518400,bg_color:"rgba(171,146,236,0.4)"}}},a=()=>navigator.language||navigator.userLanguage||"en-us",u=t=>s.a.locale(t)
/****************************************************************************  HTML *****************************************************************/
/**
 * Date formatter. Ignores timezone.
 * @param {string | number | Date} date - Valid date
 * @param {string} [format] - custom date format (optional)
 */,d=Object(i.d)((t,e=null)=>n=>{const i=e||s.a.localeData().longDateFormat("L");let r=t?s()(t).format(i):void 0;n.setValue(r)}),l=(Object(i.d)((t,e=null)=>n=>{const i=s.a.tz.guess(),r=e||s.a.localeData().longDateFormat("L");let o=t?s.a.tz(t,i).format(r):void 0;n.setValue(o)}),Object(i.d)((t,e=null)=>n=>{const i=s.a.tz.guess(),r=e||s.a.localeData().longDateFormat("L")+" HH:mm";let o=t?s.a.tz(t,i).format(r):void 0;n.setValue(o)})),E=(Object(i.d)((t,e,n=c)=>i=>{if(null!=t&&n&&Object.keys(n).length){
// Priorità a livelli
let e=n.priorityValues[t];i.setValue(n.priorityLevels[e].bg_color)}else
// Priorità standard T/F
e?i.setValue("rgba(237,85,101,0.4)"):i.setValue("inherit")}),(t,e=null)=>{const n=e||s.a.localeData().longDateFormat("L");return t?s()(t).format(n):void 0}),_=(t,e=null)=>{const n=s.a.tz.guess(),i=e||s.a.localeData().longDateFormat("L")+" HH:mm";return t?s.a.tz(t,n).format(i):void 0},T=t=>Object(r.a)("STATUS."+t),f=(t,e)=>{if(!t||!e)return t;let n;return e.split(".").some(e=>{if(void 0===t||null==t[e])return n=void 0,!0;n=t[e],t=t[e]}),n},p=(t,e,n)=>{if(e){let i=e.split(".");i.forEach((e,r)=>{r==i.length-1?t[e]=n:(null==t[e]&&(t[e]={}),t=t[e])})}return t},h=t=>{let e=typeof t;return"object"===e&&Object.prototype.toString.call(t).match(/array/i)&&(e="array"),e},S=Object(i.d)((t,e)=>n=>{if(!t){const t=n.committer.name;return void n.committer.element.removeAttribute(t)}let r=f(t,e);if(null==r&&n instanceof i.a){if(r!==n.value){const t=n.committer.name;n.committer.element.removeAttribute(t)}}else n.setValue(r)}),I=t=>{switch(t){
// KIT / IMBUSTATI
case"NEW":case"ACCD":return"check";case"C":return"thumbs-up";case"CDS":return"spinner";
//non va
case"D":return"dolly";case"LOST":return"exclamation";case"W":return"building";case"WIP":return"hourglass";case"SW":return"hand-sparkles";case"NC":return"dumpster";case"RI":return"recycle";case"RSM":return"hospital";case"T":return"user-tie";case"SHPBLDEP":return"warehouse";case"SHPBLW":return"box-open";case"SHPBLD":return"truck";case"PCW":return"pallet";case"SD":return"truck";case"SWA":return"suitcase";case"SL":return"trailer";case"DD":return"bug";case"DREP":return"ban";case"DWA":return"bug";case"ST":return"temperature-high";case"U":return"bacterium";case"N":
// new
return"file";case"INCOMPLETE":return"minus-circle";case"CONSUMED":return"box-open";case"CONTAINER":return"business-time";case"STER_CONTRACT_WORK":return"file-invoice-dollar";case"ACCEPTED_CLEANED":return"shopping-basket";case"ACCEPTED":return"vote-yea";case"PACKED":case"PACKAGED":case"P":
// Confezionato
return"box";case"STERILIZED":return"hourglass-end";case"F":return"square-full";case"L":return"soap";case"WASHED":return"shower";case"PARTIAL_WASHED":return"wind";case"PARTIAL_CONTAINER_W":case"CONTAINER_WASH":case"CONTAINER_AUTO":return"shopping-cart";case"PARTIAL_WASHED_w":return"fill-drip";case"ASSOCIATED":case"ASSOCIATED_WASH":case"ASSOCIATED_AUTO":case"PARTIAL_ASSOCIATED_W":return"business-time";case"REORDERED":return"sort-amount-up-alt";case"INVALID":case"INVALIDATED":return"exclamation-triangle";case"SHIPPABLE":return"boxes";case"SENT":case"S":
// spedito
return"shipping-fast";case"AUTOCLAVE":return"tachometer-alt";case"USED":return"box-open";case"COLLECTED":return"atom";
// ORDINI
case"TO_DISPATCH":return"clipboard-list";case"DISPATCHABLE":return"check";case"DISPATCHED":return"truck";case"CANCELED":return"ban";case"TO_CONFIRM":return"pause-circle";
//NUOVI STATI JMS
case"LOADED":return"truck-loading";case"DIRTY":return"disease";case"TRANSIT":return"route";case"CHECKOUT":return"sign-out-alt";case"CHECKIN":return"sign-in-alt";case"UNLOADED":return"people-carry";case"NOT_RECEIVED":return"exclamation-circle";case"RDY_TO_SEND_SUP":return"pallet";case"RECEIVED":return"store-alt";case"RET_TO_SUP":case"RDY_TO_SND_CUS":return"shipping-fast";case"RDY_TO_RECEIVE":return"envelope-open";case"STER_CHECKED":return"check-double";case"WAREHOUSE":return"warehouse";case"STORED":return"store";case"DELIVERED":return"truck";case"NOT_ACCEPTED":return"ban";case"TAKEN":return"box-open";case"EXPIRED":return"exclamation-triangle";case"AVAILABLE":return"box-open";case"CONTAINS_KIT":return"toolbox";case"CONTAINS_CONTAINER":return"container-storage";case"DECONTAMINATOR":return"biohazard";case"WASHING_EQUIPMENT":return"wind";case"OPERATOR":return"male";case"CONTAINER_FULL":return"box";case"CONTAINER_WASHED":return"shower";case"DIRTY_DELIVERED":return"shipping-fast";case"DIRTY_COLLECTED":return"atom";case"E":
// Rientrato
return"arrow-alt-circle-left";case"A":
// Dismesso
return"user-slash";case"TO_REPAIR":return"tools";
// inventario
case"OPEN":return"envelope-open";case"CLOSED":return"envelope";case"PROCESSING":return"spinner";
// Gestione Depositi
case"WARDROBE":return"warehouse";case"SENT_WARDROBE":return"shipping-fast";case"PENDING":return"pause-circle";case"SENT_TO_SAP":return"share-square";case"SAP_CLOSED":return"check-circle";case"N_CONFIRMED":return"window-close";default:return t}},C=(t,e,n=c)=>{if(null!=t&&n&&Object.keys(n).length){
// Priorità a livelli
let e=n.priorityValues[t];return n.priorityLevels[e].bg_color}
// Priorità standard T/F
return e||"T"===e?"rgba(237,85,101,0.4)":"inherit"},m=t=>{let e=(t=>{let e={};for(let n in t.priorityValues)e[n]=t.priorityLevels[t.priorityValues[n]];return e})(t),n=[];for(let t in e)n.push(e[t]);return n},R=()=>{let t="",e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";for(let n=0;n<10;n++)t+=e.charAt(Math.floor(Math.random()*e.length));return t},A=()=>new Audio("assets/sounds/read.mp3").play(),O=()=>new Audio("assets/sounds/error.mp3").play(),D=()=>{i.i.clear()},N=t=>T(t),b=class{constructor({namespace:t,fallback:e}){this._namespace=t,this._fallback=e||"COMMON"}do(t,e){return Object(r.b)(this._namespace,this._fallback,t,e)}}},
/***/N7YF:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o})),
/* harmony export (binding) */n.d(e,"d",(function(){return s}));const i="SET_CALLER",r="SET_SIZE_TAKING_EMPLOYEE_ID",o=t=>({type:i,caller:t}),s=t=>({type:r,employeeId:t})},
/***/Nchs:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"c",(function(){return s}));
/* unused harmony export setBoxingSelectedDestination */
/* unused harmony export setBoxingContainer */
/* unused harmony export setBoxingContainerType */
/* unused harmony export setBoxingDepartmentDestination */
const i="SET_BOXING_SELECTED_DESTINATION",r="SET_BOXING_CONTAINER",o="SET_BOXING_CONTAINER_TYPE",s="SET_BOXING_DEPARTMENT_TYPE"},
/***/Ngkx:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_AGREEMENT_ACTIVE_FILTERS",r=t=>({type:i,activeFilters:t})
/***/},
/***/OLad:
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=n("afDP"),o=n("jimv");
/* harmony import */class s extends i.b{static get styles(){return[r.a]}static get properties(){return{page:{type:String},bookmarks:{type:Object},orientation:{type:String},menuByObject:{type:Object}}}constructor(){super()}render(){return i.d`
      <nav class="toolbar-list" sticky>
        <vaadin-tabs theme="equal-width-tabs" orientation="${this.orientation}">
          <vaadin-tab ?selected="${"home"===this.page}" class="tabs" @click="${()=>this._onClick("?home")}">
            <fontawesome-icon prefix="fas" name="home"></fontawesome-icon>
            <span>${Object(o.a)("COMMON.HOME_PAGE")}</span>
          </vaadin-tab>
          ${this.bookmarks.map(t=>i.d`
              <vaadin-tab ?selected="${this.page===t.code}" class="tabs" @click="${()=>this._onClick(t.code)}">
                ${this._itemIcon(t)}
                <span>${t.description}</span>
              </vaadin-tab>
            `)}
        </vaadin-tabs>
      </nav>
    `}_itemIcon(t){return t.icon=this.menuByObject&&this.menuByObject[t.code]&&this.menuByObject[t.code].icon?this.menuByObject[t.code].icon:t.icon,t.icon&&"-"!==t.icon&&"--"!==t.icon?t.icon.indexOf("ict:")>-1?i.d` <iron-icon class="icon-small-iron fa-fw" prefix="fas" icon="${t.icon}"></iron-icon> `:t.icon&&"-"!==t.icon&&"--"!==t.icon?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="${t.icon}" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small fa-fw" prefix="fas" name="file"></fontawesome-icon> `}_onClick(t){this.dispatchEvent(new CustomEvent("tabSelect",{detail:{value:t}}))}}window.customElements.define("tab-menu",s)},
/***/OnNW:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i}));
/* unused harmony export setJsfAction */
const i="SET_JSF_ACTION"},
/***/QfXm:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_NEW_COMPONENT_LIST",r=t=>({type:i,list:t})
/***/},
/***/RXvc:
/***/function(t,e,n){"use strict";
// EXTERNAL MODULE: ./node_modules/lit-element/lit-element.js?babel-target=es6 + 5 modules
var i=n("Rukz");
// EXTERNAL MODULE: ./node_modules/fontawesome-icon/fontawesome-icon.js?babel-target=es6
n("SMGt");
// CONCATENATED MODULE: ./src/classes/six-toast.js?babel-target=es6
!function(){
// Toast container
let t=document.createElement("div");t.id="vanillatoasts-container",document.body.appendChild(t),r({position:"top-end"})}(),function(){
// language=css
const t=i.c`
    #vanillatoasts-container {
      position: fixed;
      width: auto;
      max-width: 350px;
      font-family: 'Roboto', Arial, Helvetica, sans-serif;
      z-index: 1000000;
    }

    .top-start {
      top: 0;
      left: 0;
    }

    .top-center {
      top: 0%;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .top-end {
      top: 0;
      right: 0;
    }

    .middle-start {
      top: 40vh;
      left: 0;
    }

    .middle-center {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .middle-end {
      top: 40vh;
      right: 0;
    }

    .bottom-start {
      bottom: 0;
      left: 0;
    }

    .bottom-center {
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .bottom-end {
      bottom: 0;
      right: 0;
    }

    .vanillatoasts-toast {
      position: relative;
      padding: 15px;
      margin: 20px;
      background: #f5f5f5;
      cursor: pointer;
      max-width: 350px;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
      animation-duration: 0.3s;
      animation-name: VanillaToasts;
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      border-radius: 9px;
      display: grid;
    }

    .vanillatoasts-persistent {
      cursor: auto;
    }

    .vanillatoasts-fadeOut {
      animation-name: VanillaToastsFadeOut;
      animation-duration: 0.3s;
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      animation-fill-mode: forwards;
    }

    #vanillatoasts-container p,
    #vanillatoasts-container h4 {
      margin: 3px 0 !important;
    }

    .vanillatoasts-title {
      font-weight: 700;
      font-size: 15px;
      margin-bottom: 10px;
      overflow-wrap: break-word;
    }

    .vanillatoasts-text-icon-container {
      display: flex;
    }

    .vanillatoasts-text {
      font-size: 14px;
      color: #fff;
      overflow-wrap: break-word;
    }

    .vanillatoasts-icon {
      margin-right: 5px;
    }

    .vanillatoasts-template-wrapper {
      overflow-wrap: break-word;
    }

    .vanillatoasts-toast a,
    .vanillatoasts-toast a:hover {
      color: #549edb !important;
      text-decoration: none !important;
    }

    /** toast types */
    .vanillatoasts-success {
      background-color: #15cd72;
    }

    .vanillatoasts-success > .vanillatoasts-text,
    .vanillatoasts-success > .vanillatoasts-text-icon-container > .vanillatoasts-text {
      color: #282828;
    }

    .vanillatoasts-warning {
      background-color: #ffb40c;
    }

    .vanillatoasts-warning > .vanillatoasts-text,
    .vanillatoasts-warning > .vanillatoasts-text-icon-container > .vanillatoasts-text {
      color: #282828;
    }

    .vanillatoasts-error {
      background-color: #e0455e;
    }

    .vanillatoasts-error > .vanillatoasts-text,
    .vanillatoasts-error > .vanillatoasts-text-icon-container > .vanillatoasts-text {
      color: #282828;
    }

    .vanillatoasts-info > .vanillatoasts-text,
    .vanillatoasts-info > .vanillatoasts-text-icon-container > .vanillatoasts-text {
      color: #777;
    }

    .vanillatoasts-confirm-button {
      padding: 0px 10px !important;
      border: 1px solid #fff;
      -webkit-transition: all 0.1s;
      -moz-transition: all 0.1s;
      -ms-transition: all 0.1s;
      transition: all 0.1s;
      margin: 10px 10px 0px 10px;
      position: relative;
      float: right;
      cursor: pointer;
      font-weight: 600;
      background-color: #fff;
      color: #475c7b;
      font-size: 13px;
      border-radius: 4px;
      height: 30px;
      line-height: 30px;
    }

    .vanillatoasts-cancel-button {
      padding: 0px 10px !important;
      border: 1px solid #fff;
      -webkit-transition: all 0.1s;
      -moz-transition: all 0.1s;
      -ms-transition: all 0.1s;
      transition: all 0.1s;
      margin: 10px 10px 0px 10px;
      position: relative;
      background-color: transparent;
      color: #fff;
      float: right;
      cursor: pointer;
      font-weight: 600;
      font-size: 13px;
      border-radius: 4px;
      height: 30px;
      line-height: 30px;
    }

    @keyframes VanillaToasts {
      from {
        transform: translate3d(0, -400px, 0);
        opacity: 0;
      }
      to {
        transform: translate3d(0, 0, 0);
        opacity: 1;
      }
    }

    @keyframes VanillaToastsFadeOut {
      from {
        transform: translate3d(0, 0, 0);
        opacity: 1;
      }
      to {
        transform: translate3d(0, -400px, 0);
        opacity: 0;
      }
    }
  `.toString(),e=document.createElement("style");e.innerText=t;document.getElementsByTagName("head")[0].appendChild(e)}
// EXTERNAL MODULE: ./src/providers/translationProvider.js?babel-target=es6
();function r(t){const e=document.getElementById("vanillatoasts-container");e&&t.position&&(e.classList=[],e.classList.add(t.position))}var o=n("jimv");
// CONCATENATED MODULE: ./src/components/six-message.js?babel-target=es6
const s=new class{constructor(){this._autoincrement=0,this.toasts={}}
/**
   * Message options
   * @typedef {Object} ToastOptions
   * @property {string} title - The title
   * @property {string} message - The message
   * @property {string} icon - The icon source
   * @property {'top-stretch'|'top-start'|'top-center'|'top-end'|'middle'|'bottom-start'|'bottom-center'|'bottom-end'|'bottom-stretch'} position - The position
   * @property {number} duration - The duration
   * @property {'info'|'error'|'warning'|'success'} type - The toast type
   * @property {boolean} okButton - show ok action button on notification
   * @property {boolean} cancelButton - show cancel action button on notification
   * @property {string} okButtontext - ok action button label
   * @property {function} onOkButtonClick - callback on ok button click
   * @property {function} onCancelButtonClick - callback on cancel button click
   * @property {function} onDismiss - callback on toast dismiss
   * @property {Object} customStyle - css custom
   */
/**
   * @param {ToastOptions} options
   */create(t){let e=document.createElement("div");// title
if(e.id=++this._autoincrement,e.id="toast-"+e.id,e.className="vanillatoasts-toast",t.title){let n=document.createElement("h4");n.className="vanillatoasts-title",n.innerHTML=t.title,e.appendChild(n)}if(t.message&&t.icon){let n=document.createElement("div");n.className="vanillatoasts-text-icon-container";let i=document.createElement("p");i.className="vanillatoasts-text",i.innerHTML=t.message;let r=document.createElement("div");r.className="vanillatoasts-icon",r.innerHTML=`<fontawesome-icon fixed-width prefix="${t.icon.prefix||"fas"}" name="${t.icon.icon}"></fontawesome-icon>`,n.appendChild(r),n.appendChild(i),e.appendChild(n)}else{
// text
if(t.message){let n=document.createElement("p");n.className="vanillatoasts-text",n.innerHTML=t.message,e.appendChild(n)}// icon
if(t.icon){let n=document.createElement("div");n.className="vanillatoasts-icon",n.innerHTML=`<fontawesome-icon fixed-width prefix="${t.icon.prefix||"fas"}" name="${t.icon.icon}"></fontawesome-icon>`,e.appendChild(n)}}if(t.template){let n=document.createElement("div");n.id="vanillatoasts-template-wrapper",n.className="vanillatoasts-template-wrapper",n.innerHTML=t.template,e.appendChild(n)}if(t.okButton||t.cancelButton){let t=document.createElement("div");t.id="vanillatoasts-button-wrapper",t.className="vanillatoasts-button-wrapper",e.appendChild(t)}if(t.cancelButton){let n=document.createElement("button");t.onCancelButtonClick&&n.addEventListener("click",()=>t.onCancelButtonClick(e)),n.className="vanillatoasts-cancel-button",n.innerHTML=t.cancelButtonText||"Cancel",e.getElementsByClassName("vanillatoasts-button-wrapper")[0].appendChild(n)}// ok button
if(t.okButton){let n=document.createElement("button");t.onOkButtonClick&&n.addEventListener("click",()=>t.onOkButtonClick(e)),n.className="vanillatoasts-confirm-button",n.innerHTML=t.okButtonText||"Ok",e.getElementsByClassName("vanillatoasts-button-wrapper")[0].appendChild(n)}t.data&&(e.data=t.data);const n=()=>{t.onDismiss&&t.onDismiss(e),document.getElementById("vanillatoasts-container").removeChild(e),delete this.toasts[e.id]}//remove toast from object;
// toast api
// customStyle
if(e.hide=()=>{e.className+=" vanillatoasts-fadeOut",e.addEventListener("animationend",n,!1)},// autohide
t.duration?(setTimeout(e.hide,t.duration),e.addEventListener("click",e.hide)):e.classList.add("vanillatoasts-persistent"),t.type&&(e.className+=" vanillatoasts-"+t.type),t.customStyle&&Object.keys(t.customStyle)&&Object.keys(t.customStyle).length){let n=t.customStyle;for(let t in n)e.style[t]=n[t]}return document.getElementById("vanillatoasts-container").appendChild(e),//add toast to object so its easily gettable by its id
this.toasts[e.id]=e,e}
/**
   * Config options
   * @typedef {Object} ConfigOptions
   * @property {'top-start'|'top-center'|'top-end'|'middle-start'| 'middle-center'| 'middle-end'| 'bottom-start'|'bottom-center'|'bottom-end'} position - The position
   */
/**
   * @param {ConfigOptions} options
   */config(t){r(t)}};class c extends i.b{constructor(){super()}static get properties(){return{position:{type:String}}}updated(t){t.has("position")&&this.position&&s.config({position:this.position})}connectedCallback(){super.connectedCallback(),document.addEventListener("new-sx-message",a)}disconnectedCallback(){document.removeEventListener("new-sx-message",a),super.disconnectedCallback()}
/**--------------------------- */}function a(t){t.stopPropagation(),s.create({title:t.detail.message.title,icon:t.detail.message.icon,message:t.detail.message.message,duration:t.detail.message.duration,type:t.detail.message.type,okButton:t.detail.message.okButton,cancelButton:t.detail.message.cancelButton,okButtonText:t.detail.message.okButtonText||Object(o.a)("COMMON.OK"),cancelButtonText:t.detail.message.cancelButtonText||Object(o.a)("COMMON.CANCEL"),data:{promise:t.detail.promise,data:t.detail.data},template:t.detail.message.template,customStyle:t.detail.message.customStyle,onOkButtonClick:t=>{t.hide();(0,t.data.promise.resolve)(t.data.data||!0),delete t.data},onCancelButtonClick:t=>{t.hide();(0,t.data.promise.reject)(t.data.data||!1),delete t.data},onDismiss:t=>{if(t.data){(0,t.data.promise.resolve)(t.data.data||!0),delete t.data}}})}window.customElements.define("six-message",c)},
/***/THwi:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"h",(function(){return i})),
/* unused harmony export setOrdersList */
/* harmony export (binding) */n.d(e,"k",(function(){return r})),
/* unused harmony export setSealedOrderSelected */
/* harmony export (binding) */n.d(e,"e",(function(){return o})),
/* unused harmony export setKitsByStatus */
/* harmony export (binding) */n.d(e,"d",(function(){return s})),
/* unused harmony export setKitsByOrder */
/* harmony export (binding) */n.d(e,"b",(function(){return c})),
/* unused harmony export openDetail */
/* harmony export (binding) */n.d(e,"a",(function(){return a})),
/* unused harmony export closeDetail */
/* harmony export (binding) */n.d(e,"q",(function(){return u})),
/* unused harmony export toggleSidebar */
/* harmony export (binding) */n.d(e,"p",(function(){return d})),
/* unused harmony export toggleSealedSidebar */
/* harmony export (binding) */n.d(e,"m",(function(){return l})),
/* unused harmony export setSelectedOrderStatus */
/* harmony export (binding) */n.d(e,"g",(function(){return E})),
/* unused harmony export setOptions */
/* harmony export (binding) */n.d(e,"o",(function(){return _})),
/* unused harmony export setTotalKits */
/* harmony export (binding) */n.d(e,"l",(function(){return T})),
/* unused harmony export setSelectedOrderList */
/* harmony export (binding) */n.d(e,"c",(function(){return f})),
/* unused harmony export setDetailList */
/* harmony export (binding) */n.d(e,"i",(function(){return p})),
/* unused harmony export setOrderChecked */
/* harmony export (binding) */n.d(e,"j",(function(){return h})),
/* unused harmony export setOrderUnchecked */
/* harmony export (binding) */n.d(e,"n",(function(){return S})),
/* unused harmony export setSelectAll */
/* harmony export (binding) */n.d(e,"f",(function(){return I}));
/* unused harmony export setLateAllowedPErmit */
const i="SET_ORDERS_LIST",r="SET_SEALED_ORDER_SELECTED",o="SET_KITS_BY_STATUS",s="SET_KITS_BY_ORDER",c="OPEN_DETAIL",a="CLOSE_DETAIL",u="TOGGLE_SIDEBAR",d="TOGGLE_SEALED_SIDEBAR",l="SET_SELECTED_ORDER_STATUS",E="SET_OPTIONS",_="SET_TOTAL_KITS",T="SET_SELECTED_ORDER_LIST",f=" SET_DETAIL_LIST",p="SET_ORDER_CHECKED",h="SET_ORDER_UNCHECKED",S="SET_SELECT_ALL",I="SET_LATE_ALLOWED_PERMIT"},
/***/Tv4f:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"f",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"a",(function(){return o})),
/* harmony export (binding) */n.d(e,"g",(function(){return s})),
/* harmony export (binding) */n.d(e,"b",(function(){return c})),
/* harmony export (binding) */n.d(e,"c",(function(){return a})),
/* harmony export (binding) */n.d(e,"d",(function(){return u})),
/* harmony export (binding) */n.d(e,"m",(function(){return d})),
/* harmony export (binding) */n.d(e,"l",(function(){return l})),
/* harmony export (binding) */n.d(e,"h",(function(){return E})),
/* harmony export (binding) */n.d(e,"n",(function(){return _})),
/* harmony export (binding) */n.d(e,"i",(function(){return T})),
/* harmony export (binding) */n.d(e,"j",(function(){return f})),
/* harmony export (binding) */n.d(e,"k",(function(){return p}));const i="SET_SELECTED_AGREEMENTS",r="SET_NEW_ENDOWMENT",o="SET_ENDOWMENT_ACTIVE_GRID_FILTERS",s="SET_SELECTED_ROW_ENDOWMENT_BALANCE",c="SET_ENDOWMENT_BALANCE_ACTIVE_GRID_FILTERS",a="SET_ENDOWMENT_BALANCE_PAGE",u="SET_ENDOWMENT_DETAIL_CALLER",d=t=>({type:i,selectedAgreements:t}),l=t=>({type:r,newEndowment:t}),E=t=>({type:o,filters:t}),_=t=>({type:s,row:t}),T=t=>({type:c,balanceFilters:t}),f=t=>({type:a,balancePage:t}),p=t=>({type:u,detailCaller:t})},
/***/Uapg:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"h",(function(){return a})),
/* unused harmony export setJsondataSelectedOrder */
/* harmony export (binding) */n.d(e,"g",(function(){return u})),
/* harmony export (binding) */n.d(e,"f",(function(){return d}));
/* unused harmony export setJsondataCaller */
const i="SET_JSONDATA_LIST",r="SET_JSONDATA_SELECTED_ORDER",o="SET_JSONDATA_ACTIVE_PAGE",s="SET_JSONDATA_ACTIVE_GRID_FILTERS",c="SET_JSONDATA_CALLER",a=t=>({type:i,jsondataList:t}),u=t=>({type:o,page:t}),d=t=>({type:s,filters:t})},
/***/Uolk:
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=n("afDP"),o=(n("O5j2"),n("oDC5"),n("1UqG"),n("hSgB"),n("N+pe")),s=n("jimv");
/* harmony import */class c extends i.b{static get styles(){return[r.D,r.i]}render(){switch(this.type){case"number":return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-number-field
            id="${this._id}"
            name="${this._id}"
            label="${this.label||""}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="number"
            ?clear-button-visible="${!this.hasControls}"
            ?has-controls="${this.hasControls}"
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-number-field>
        `;case"email":return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-email-field
            id="${this._id}"
            name="${this._id}"
            label="${this.label||""}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="email"
            clear-button-visible
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-email-field>
        `;case"password":return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-password-field
            id="${this._id}"
            label="${this.label||""}"
            name="${this._id}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="password"
            clear-button-visible
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-password-field>
        `;default:return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-text-field
            id="${this._id}"
            name="${this._id}"
            label="${this.label||""}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="text"
            clear-button-visible
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-text-field>
        `}}static get properties(){return{label:{type:String},placeholder:{type:String},value:{type:String},style:{type:String},required:{type:Boolean},errormessage:{type:String},maxlength:{type:Number},minlength:{type:Number},disabled:{type:Boolean},readonly:{type:Boolean},type:{type:String},checkValidity:{attribute:!1},validate:{attribute:!1},reset:{attribute:!1},hasControls:{type:Boolean},step:{type:String},min:{type:String},max:{type:String},pattern:{type:String},getValueAsNumber:{type:Boolean},noAutoAction:{type:Boolean},autoFocus:{type:Boolean}}}get value(){return this.getValueAsNumber&&"number"==this.type?Number(this._value):this._value}set value(t){const e=this._value;this._value=t,this.requestUpdate("value",e)}constructor(){super(),this._id=Object(o.l)(),this.style="",//private property to keep a 1:1 relashionship between the value
//of the vaadin component and the value of the six component
this._value=""}firstUpdated(){this._element=this.shadowRoot.querySelector("#"+this._id),this.errorMessage||(this._noErrorMessage=!0),this.type&&"number"==this.type&&(null!=this.step&&this._element.setAttribute("step",Number(this.step)),null!=this.min&&this._element.setAttribute("min",Number(this.min)),null!=this.max&&this._element.setAttribute("max",Number(this.max))),this._getDefaultMessage(),this.checkValidity=()=>this._element.checkValidity(),this.validate=()=>{this._element.validate(),this._getDefaultMessage()},this.reset=()=>{this._value="",this._element.clear(),//set this._element.value = ''
this._element.invalid=!1,this._element.removeAttribute("invalid"),this._getDefaultMessage()},this.autoFocus&&this.sixFocusElement()}updated(t){if((t.has("max")||t.has("min"))&&this.type&&"number"==this.type&&(null!=this.step&&this._element.setAttribute("step",Number(this.step)),null!=this.min&&this._element.setAttribute("min",Number(this.min)),null!=this.max&&this._element.setAttribute("max",Number(this.max))),t.has("pattern")&&null!=this.pattern&&(this._element.pattern=this.pattern),t.has("value")&&(this._element.value=this._value,!this.noAutoAction)){const t={currentTarget:{value:this.value}};this._oninputchange(t),this._onKeyPress(t)}}sixFocusElement(t=0){if(!this._element||!this._element.shadowRoot||null==this._element.shadowRoot.querySelector("input"))return t<10?this.updateComplete.then(()=>this.sixFocusElement(t+1)):void 0;this._element.shadowRoot.querySelector("input").focus()}_getDefaultMessage(){if(this._noErrorMessage){switch(this._element.getAttribute("type")){case"number":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.errorMessage=Object(s.a)("COMMON.INVALID_NUMBER"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(s.a)("COMMON.REQUIRED");break;case"email":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.this._element.errorMessage=Object(s.a)("COMMON.INVALID_EMAIL_ADDRESS"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(s.a)("COMMON.REQUIRED");break;case"password":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.errorMessage=Object(s.a)("COMMON.INVALID_PASSWORD"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(s.a)("COMMON.REQUIRED");break;case"text":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.errorMessage=Object(s.a)("COMMON.INVALID_TEXT"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(s.a)("COMMON.REQUIRED");break;default:this._element.errorMessage=""}}}_onKeyPress(t){let e=t.currentTarget.value;this.getValueAsNumber&&"number"==this.type&&(e=Number(e)),//since the value comes from the vaadin component we dont need to trigger template rendering to
//update the view, we only need to make sure the six component has the updated value
this._value=e,this.dispatchEvent(new CustomEvent("key-press",{detail:{value:e}})),setTimeout(()=>{this._getDefaultMessage()})}_oninputchange(t){let e=t.currentTarget.value;e&&this.getValueAsNumber&&"number"==this.type&&(e=Number(e)),//since the value comes from the vaadin component we dont need to trigger template rendering to
//update the view, we only need to make sure the six component has the updated value
this._value=e,this.dispatchEvent(new CustomEvent("change",{detail:{value:e}})),setTimeout(()=>{this._getDefaultMessage()})}}window.customElements.define("six-input",c)},
/***/VMCu:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_CALLER",r=t=>({type:i,caller:t})
/***/},
/***/"W4+H":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"m",(function(){return i})),
/* harmony export (binding) */n.d(e,"j",(function(){return r})),
/* harmony export (binding) */n.d(e,"D",(function(){return o})),
/* harmony export (binding) */n.d(e,"l",(function(){return s})),
/* harmony export (binding) */n.d(e,"B",(function(){return c})),
/* harmony export (binding) */n.d(e,"z",(function(){return a})),
/* harmony export (binding) */n.d(e,"b",(function(){return u})),
/* harmony export (binding) */n.d(e,"g",(function(){return d})),
/* harmony export (binding) */n.d(e,"n",(function(){return l})),
/* harmony export (binding) */n.d(e,"o",(function(){return E})),
/* harmony export (binding) */n.d(e,"s",(function(){return _})),
/* harmony export (binding) */n.d(e,"p",(function(){return T})),
/* harmony export (binding) */n.d(e,"E",(function(){return f})),
/* harmony export (binding) */n.d(e,"F",(function(){return p})),
/* harmony export (binding) */n.d(e,"f",(function(){return h})),
/* harmony export (binding) */n.d(e,"c",(function(){return S})),
/* harmony export (binding) */n.d(e,"G",(function(){return I})),
/* harmony export (binding) */n.d(e,"C",(function(){return C})),
/* harmony export (binding) */n.d(e,"t",(function(){return m})),
/* unused harmony export DELETE_CUSTOMER_ORDER_ROW */
/* harmony export (binding) */n.d(e,"A",(function(){return R})),
/* harmony export (binding) */n.d(e,"i",(function(){return A})),
/* harmony export (binding) */n.d(e,"k",(function(){return O})),
/* harmony export (binding) */n.d(e,"d",(function(){return D})),
/* harmony export (binding) */n.d(e,"y",(function(){return N})),
/* harmony export (binding) */n.d(e,"v",(function(){return b})),
/* harmony export (binding) */n.d(e,"w",(function(){return L})),
/* harmony export (binding) */n.d(e,"h",(function(){return g})),
/* harmony export (binding) */n.d(e,"a",(function(){return v})),
/* harmony export (binding) */n.d(e,"e",(function(){return y})),
/* harmony export (binding) */n.d(e,"u",(function(){return P})),
/* harmony export (binding) */n.d(e,"x",(function(){return k})),
/* harmony export (binding) */n.d(e,"r",(function(){return w})),
/* harmony export (binding) */n.d(e,"q",(function(){return M}));
/* unused harmony export setOrderPriority */
/* unused harmony export hideOrder */
/* unused harmony export setSealedOrderType */
/* unused harmony export setKitOrderType */
/* unused harmony export setCustomerDestination */
/* unused harmony export setCheckinDestination */
/* unused harmony export setCustomerOrderNote */
/* unused harmony export setCustomerOrderReturnSheet */
/* unused harmony export setSerialKitPriority */
/* unused harmony export setSerialKitNote */
/* unused harmony export selectOrder */
/* unused harmony export setSealedProductsList */
/* unused harmony export setIncomingMaterialsList */
/* unused harmony export setOrderRows */
/* unused harmony export setCustomer */
/* unused harmony export setPrioritiesList */
/* unused harmony export setOrdersList */
/* unused harmony export addOrder */
/* unused harmony export removeOrder */
/* unused harmony export unselectOrder */
/* unused harmony export setAdditionalInfoVisible */
/* unused harmony export setLoanedForm */
/* unused harmony export setNewloanedOrder */
/* unused harmony export setLoanedSerialKitId */
/* unused harmony export setLoanedProductId */
/* unused harmony export setLoanedSerialKitImages */
/* unused harmony export setActiveLoanedSerialKitImageId */
/* unused harmony export addLoanedImage */
/* unused harmony export removeLoanedImage */
/* unused harmony export setLoanedSerialKitImagesList */
/* unused harmony export setDirtyAcceptanceSelectedKitForMaintenance */
/* unused harmony export setDirtyAcceptanceSelectedComponentForMaintenance */
const i="SET_CUSTOMER_DESTINATION",r="SET_CHECKIN_DESTINATION",o="SET_SEALED_PRODUCTS_LIST",s="SET_CUSTOMER",c="SET_PRIORITIES_LIST",a="SET_ORDERS_LIST",u="ADD_ORDER",d="SELECT_ORDER",l="SET_CUSTOMER_ORDER_NOTE",E="SET_CUSTOMER_ORDER_RETURN_SHEET",_="SET_INCOMING_MATERIALS",T="SET_CUSTOMER_ORDER_ROWS",f="SET_SERIAL_KIT_NOTE",p="SET_SERIAL_KIT_PRIORITY",h="REMOVE_ORDER",S="HIDE_ORDER",I="UNSELECT_ORDER",C="SET_SEALED_ORDER_TYPE",m="SET_KIT_ORDER_TYPE",R="SET_ORDER_PRIORITY",A="SET_ADDITIONAL_INFO_VISIBLE",O="SET_CODE_READ",D="LOANED_FORM_FIELD_CHANGED",N="SET_NEW_LOANED_ORDER",b="SET_LOANED_SERIAL_KIT_ID",L="SET_LOANED_SERIAL_KIT_IMAGE",g="SET_ACTIVE_LOANED_SERIAL_KIT_IMAGE_ID",v="ADD_LOANED_IMAGE",y="REMOVE_LOANED_IMAGE",P="SET_LOANED_PRODUCT_KIT_ID",k="SET_LOANED_SERIAL_KIT_IMAGES_LIST",w="SET_DIRTYACCEPTANCE_SELECTED_KIT_FOR_MAINTENANCE",M="SET_DIRTYACCEPTANCE_SELECTED_COMPONENT_FOR_MAINTENANCE"},
/***/WKed:
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=(n("SMGt"),n("afDP")),o=n("4fQY");
/* harmony import */
// This element is *not* connected to the Redux store.
class s extends i.b{static get styles(){return[r.M]}render(){return i.d`
      <button
        class="btn ${this.class||"btn-sm btn-default"}"
        type="${this.type||"button"}"
        @click="${t=>this._onClick(t)}"
        ?disabled="${this._isDisabled()}"
        style="${(this.style||"")+(this.color?";background-color:"+this.color:"")}"
      >
        ${this.useIct&&this.icon?i.d` <iron-icon @click="${this._onClick}" icon="ict:${this.icon}" class="${this.label?"icon-margin-right":""}"></iron-icon> `:this.icon?i.d`
              <fontawesome-icon
                @click="${this._onClick}"
                prefix="${this.prefix}"
                name="${this.icon}"
                class="${this.label?"icon-margin-right":""}"
                fixed-width
              ></fontawesome-icon>
            `:o.f}
        ${this.label}
      </button>
    `}
/* ************** START: STRUTTURA BASE PAGINA ************** */static get properties(){return{label:{type:String},icon:{type:String},class:{type:String},disabled:{type:Boolean},_forceDisabled:{type:Boolean,attribute:!1},color:{type:String},prefix:{type:String},useIct:{type:Boolean},type:{type:String},style:{type:String},model:{type:Object}}}constructor(){super(),this.disabled=!1,this.prefix="fas",this._disablingPromises=[]}
/* ************** END: STRUTTURA BASE PAGINA ************** */_isDisabled(){return this.disabled||this._forceDisabled}_onClick(t){t.stopPropagation(),t.preventDefault(),this._isDisabled()||this.dispatchEvent(new CustomEvent("click",{detail:{value:{model:this.model},disable:t=>(this._forceDisabled=!0,this._disablingPromises.push(t),t.finally(()=>{this._disablingPromises.pop(),0===this._disablingPromises.length&&(this._forceDisabled=!1)}),t)}}))}}window.customElements.define("six-button",s)},
/***/YDvf:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_PACK_ACTIVE_GRID_FILTERS",r=t=>({type:i,filters:t})},
/***/Yha8:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o}));
/* unused harmony export setInvoicingPage */
/* unused harmony export setInvoicingSelectedInvoice */
/* unused harmony export setInvoicingInvoiceList */
const i="SET_INVOICING_PAGE",r="SET_INVOICING_INVOICE_LIST",o="SET_INVOICING_SELECTED_INVOICE"},
/***/"ZF+g":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"h",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"i",(function(){return o})),
/* harmony export (binding) */n.d(e,"g",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"e",(function(){return a})),
/* harmony export (binding) */n.d(e,"b",(function(){return u})),
/* harmony export (binding) */n.d(e,"f",(function(){return d})),
/* harmony export (binding) */n.d(e,"d",(function(){return l}));
/* unused harmony export setWashOrderConfirmationOrders */
/* unused harmony export setWashOrderConfirmationElementsLoaded */
/* unused harmony export setWashOrderConfirmationSelectedOrder */
/* unused harmony export setWashOrderConfirmationNotCompliantReasonList */
/* unused harmony export setWashOrderConfirmationIntegrationCycle */
/* unused harmony export setWashOrderConfirmationIntegrationWarning */
/* unused harmony export setWashOrderConfirmationIntegrationSuspended */
/* unused harmony export setWashOrderConfirmationIntegrationActive */
/* unused harmony export setWashOrderConfirmationLiveReportUrl */
const i="SET_WASHORDERCONFIRMATION_ORDERS_WOC",r="SET_WASHORDERCONFIRMATION_ELEMENTS_LOADED_WOC",o="SET_WASHORDERCONFIRMATION_SELECTED_ORDER_WOC",s="SET_WASHORDERCONFIRMATION_NOT_COMPLIANT_REASONS",c="SET_WASHORDERCONFIRMATION_INTEGRATION_CYCLE",a="SET_WASHORDERCONFIRMATION_INTEGRATION_WARNING",u="SET_WASHORDERCONFIRMATION_INTEGRATION_ACTIVE",d="SET_WASHORDERCONFIRMATION_LIVE_REPORT_URL",l="SET_WASHORDERCONFIRMATION_INTEGRATION_SUSPENDED"},
/***/bLI7:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return o}));
/* harmony import */var i=n("zbnX"),r=n("yzKQ");
/* harmony import */class o extends Promise{constructor(t){super(t)}
/**
   * Attaches callbacks for the resolution and/or rejection of the Promise.
   * @param onfulfilled — The callback to execute when the Promise is resolved.
   * @param onrejected — The callback to execute when the Promise is rejected.
   * @returns {SixPromiseResponse}— A Promise for the completion of which ever callback is executed.
   */then(t,e){return super.then.call(this,t,e)}
/**
   * Attaches a callback for only the rejection of the Promise.
   * @param onrejected — The callback to execute when the Promise is rejected.
   * @returns {SixPromiseResponse} — A Promise for the completion of the callback.
   */catch(t){return super.catch.call(this,t)}
/**
   * Attaches a callback that is invoked when the Promise is settled (fulfilled or rejected).
   * The resolved value cannot be modified from the callback.
   * @param onfinally — The callback to execute when the Promise is settled (fulfilled or rejected).
   * @returns {SixPromiseResponse} — A Promise for the completion of the callback.
   */finally(t){return super.finally.call(this,t)}
/**
   * Return the promise after catching eventual errors;
   * @returns {SixPromiseResponse} - SixPromiseResponse
   */quiet(){return this.then(t=>t,t=>t)}
/**
   * Option
   * @typedef {object} Option
   * @property {boolean} [strict] - If true, will return undfined if no result like field is found in the response.
   * @property {*} [fallback] - Value that will be returned if no result like field is found in the response. (ignored if strict = true)
   */
/**
   * if the resolved promise has a result-like field (result, list) returns a Promise with only that field
   * otherwise returns the whole promise;
   * @param {Option} options - Options
   * @returns {SixPromiseResponse} - SixPromiseResponse
   */onlyResult({strict:t,fallback:e}={strict:!1,fallback:void 0}){return this.then(n=>n.list?n.list:n.result?n.result:!0===t?void 0:void 0!==e?e:n)}onlyValue(){return this.then(t=>t&&t.value)}booleanValue(){return this.then(t=>"true"===t.value)}
/**
   * GqlOptions
   * @typedef {object} GqlOptions
   * @property {String} [field] - Returns only the selected field of the response object
   */
/**
   * Handle a graphql response type, by rejecting the promise in case of errors and providing simple utility options
   * to exract data
   * @param {GqlOptions} options - options
   */graphql({field:t}={}){return this.then(e=>{if(e.errors)throw e;return null!=t?e.data[t]:e.data})}
/**
   * Automatically handle response message by taking the provided message
   * and displaying a pop-up.
   * @param {BaseElement} thisContext - BaseElement class instance
   * @returns {SixPromiseResponse} - SixPromiseResponse
   */handleResponseMessage(t){return this.then(e=>{if(!(t instanceof i.a))throw new Error("invalid 'this' context provided, 'this' must be an instace of BaseElement Class");{const n=e&&e.messages&&e.messages[0];if(n)Object(r.a)(n.status.toLowerCase(),t.getI18nBaseKey(),void 0,n.code||n.message,n.params);else{const n=e&&e.message;n&&Object(r.a)("success",t.getI18nBaseKey(),void 0,n)}}return e},e=>{if(!(t instanceof i.a))throw new Error("invalid 'this' context provided, 'this' must be an instace of BaseElement Class");{const n=e&&e.messages&&e.messages[0];if(n)Object(r.a)(n.status.toLowerCase(),t.getI18nBaseKey(),void 0,n.code||n.message,n.params);else{const n=e&&(e.message||e.error||e.errorMessage);n&&Object(r.a)("error",t.getI18nBaseKey(),void 0,n)}}throw e})}}
/***/},
/***/c8yf:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"lb",(function(){return i})),
/* harmony export (binding) */n.d(e,"i",(function(){return r})),
/* harmony export (binding) */n.d(e,"s",(function(){return o})),
/* harmony export (binding) */n.d(e,"G",(function(){return s})),
/* harmony export (binding) */n.d(e,"a",(function(){return c})),
/* harmony export (binding) */n.d(e,"q",(function(){return a})),
/* harmony export (binding) */n.d(e,"u",(function(){return u})),
/* harmony export (binding) */n.d(e,"v",(function(){return d})),
/* harmony export (binding) */n.d(e,"mb",(function(){return l})),
/* harmony export (binding) */n.d(e,"j",(function(){return E})),
/* harmony export (binding) */n.d(e,"ob",(function(){return _})),
/* harmony export (binding) */n.d(e,"l",(function(){return T})),
/* harmony export (binding) */n.d(e,"r",(function(){return f})),
/* harmony export (binding) */n.d(e,"nb",(function(){return p})),
/* harmony export (binding) */n.d(e,"k",(function(){return h})),
/* harmony export (binding) */n.d(e,"t",(function(){return S})),
/* harmony export (binding) */n.d(e,"tb",(function(){return I})),
/* harmony export (binding) */n.d(e,"c",(function(){return C})),
/* harmony export (binding) */n.d(e,"b",(function(){return m})),
/* harmony export (binding) */n.d(e,"M",(function(){return R})),
/* harmony export (binding) */n.d(e,"P",(function(){return A})),
/* harmony export (binding) */n.d(e,"pb",(function(){return O})),
/* harmony export (binding) */n.d(e,"d",(function(){return D})),
/* harmony export (binding) */n.d(e,"m",(function(){return N})),
/* harmony export (binding) */n.d(e,"I",(function(){return b})),
/* harmony export (binding) */n.d(e,"F",(function(){return L})),
/* harmony export (binding) */n.d(e,"T",(function(){return g})),
/* harmony export (binding) */n.d(e,"S",(function(){return v})),
/* harmony export (binding) */n.d(e,"R",(function(){return y})),
/* harmony export (binding) */n.d(e,"V",(function(){return P})),
/* harmony export (binding) */n.d(e,"U",(function(){return k})),
/* harmony export (binding) */n.d(e,"A",(function(){return w})),
/* harmony export (binding) */n.d(e,"Q",(function(){return M})),
/* harmony export (binding) */n.d(e,"D",(function(){return x})),
/* harmony export (binding) */n.d(e,"W",(function(){return G})),
/* harmony export (binding) */n.d(e,"H",(function(){return K})),
/* harmony export (binding) */n.d(e,"E",(function(){return U})),
/* harmony export (binding) */n.d(e,"J",(function(){return B})),
/* harmony export (binding) */n.d(e,"rb",(function(){return H})),
/* harmony export (binding) */n.d(e,"sb",(function(){return $})),
/* harmony export (binding) */n.d(e,"x",(function(){return W})),
/* harmony export (binding) */n.d(e,"K",(function(){return j})),
/* harmony export (binding) */n.d(e,"w",(function(){return F})),
/* harmony export (binding) */n.d(e,"p",(function(){return V})),
/* harmony export (binding) */n.d(e,"f",(function(){return Y})),
/* harmony export (binding) */n.d(e,"o",(function(){return z})),
/* harmony export (binding) */n.d(e,"X",(function(){return q})),
/* harmony export (binding) */n.d(e,"z",(function(){return Q})),
/* harmony export (binding) */n.d(e,"N",(function(){return J})),
/* harmony export (binding) */n.d(e,"O",(function(){return X})),
/* harmony export (binding) */n.d(e,"g",(function(){return Z})),
/* harmony export (binding) */n.d(e,"h",(function(){return tt})),
/* harmony export (binding) */n.d(e,"qb",(function(){return et})),
/* harmony export (binding) */n.d(e,"n",(function(){return nt})),
/* harmony export (binding) */n.d(e,"B",(function(){return it})),
/* harmony export (binding) */n.d(e,"e",(function(){return rt})),
/* harmony export (binding) */n.d(e,"ub",(function(){return ot})),
/* harmony export (binding) */n.d(e,"y",(function(){return st})),
/* harmony export (binding) */n.d(e,"C",(function(){return ct})),
/* harmony export (binding) */n.d(e,"cb",(function(){return at})),
/* harmony export (binding) */n.d(e,"bb",(function(){return ut})),
/* harmony export (binding) */n.d(e,"db",(function(){return dt})),
/* harmony export (binding) */n.d(e,"ab",(function(){return lt})),
/* harmony export (binding) */n.d(e,"eb",(function(){return Et})),
/* harmony export (binding) */n.d(e,"Z",(function(){return _t})),
/* harmony export (binding) */n.d(e,"L",(function(){return Tt})),
/* harmony export (binding) */n.d(e,"fb",(function(){return ft})),
/* harmony export (binding) */n.d(e,"ib",(function(){return pt})),
/* harmony export (binding) */n.d(e,"Y",(function(){return ht})),
/* harmony export (binding) */n.d(e,"hb",(function(){return St})),
/* harmony export (binding) */n.d(e,"jb",(function(){return It})),
/* harmony export (binding) */n.d(e,"kb",(function(){return Ct})),
/* harmony export (binding) */n.d(e,"gb",(function(){return mt})),
/* unused harmony export showCameraSidebar */
/* unused harmony export viewMode */
/* unused harmony export hideCameraSidebar */
/* unused harmony export setAdmittedEquipmentReasons */
/* harmony export (binding) */n.d(e,"Db",(function(){return Rt})),
/* unused harmony export setPackDefaultLoanedProduct */
/* unused harmony export confirmSave */
/* unused harmony export unsetSaving */
/* unused harmony export setCopies */
/* unused harmony export replaceProduct */
/* unused harmony export showSterDialog */
/* unused harmony export hideSterDialog */
/* unused harmony export showReplacementDialog */
/* unused harmony export hideReplacementDialog */
/* unused harmony export showSerialKitInfoDialog */
/* unused harmony export hideSerialKitInfoDialog */
/* unused harmony export showPrintDialog */
/* unused harmony export hidePrintDialog */
/* unused harmony export restoreProduct */
/* unused harmony export undoService */
/* unused harmony export applyServiceChanges */
/* unused harmony export applyReason */
/* unused harmony export setMissingQuantity */
/* unused harmony export setOperationReasons */
/* unused harmony export incrementCheckedItems */
/* unused harmony export decrementCheckedItems */
/* unused harmony export packRow */
/* unused harmony export selectNextRow */
/* unused harmony export showServicePanel */
/* unused harmony export setServicePanelMode */
/* unused harmony export hideServicePanel */
/* harmony export (binding) */n.d(e,"vb",(function(){return At})),
/* unused harmony export setKitList */
/* unused harmony export setKitGrids */
/* unused harmony export setSealedItemsList */
/* unused harmony export setSealedList */
/* unused harmony export setSealedGrids */
/* harmony export (binding) */n.d(e,"Ab",(function(){return Ot})),
/* unused harmony export setSelectedCustomerOrder */
/* unused harmony export setSealedDetail */
/* unused harmony export setDetailRows */
/* unused harmony export setSelectedSerialKitId */
/* unused harmony export setKitInformation */
/* unused harmony export setKitContainerRows */
/* unused harmony export setKitRows */
/* unused harmony export setCheckinTree */
/* unused harmony export setKitGroupDetailOpen */
/* unused harmony export setKitGroupParentSelected */
/* unused harmony export setKitRowsImages */
/* unused harmony export setKitImages */
/* unused harmony export addCheckinImage */
/* unused harmony export removeCheckinImage */
/* unused harmony export selectKitImage */
/* unused harmony export selectCheckinImage */
/* unused harmony export resetImages */
/* unused harmony export selectRow */
/* unused harmony export setTotalItemsCount */
/* unused harmony export setCheckedItemsCount */
/* harmony export (binding) */n.d(e,"xb",(function(){return Dt})),
/* harmony export (binding) */n.d(e,"yb",(function(){return Nt})),
/* unused harmony export emptyTotalItemCount */
/* unused harmony export emptyCheckedItemCount */
/* unused harmony export setPackageSerialKitImageList */
/* unused harmony export setPackageProductImageList */
/* unused harmony export setPackageSerialKitLastCycleCode */
/* unused harmony export setPackageKitRegistryImages */
/* unused harmony export setPackageSingleProductAttachmentsList */
/* unused harmony export setPackageKitAttachmentsList */
/* harmony export (binding) */n.d(e,"wb",(function(){return bt})),
/* harmony export (binding) */n.d(e,"zb",(function(){return Lt})),
/* harmony export (binding) */n.d(e,"Cb",(function(){return gt})),
/* unused harmony export setSkOpenedPreviously */
/* harmony export (binding) */n.d(e,"Eb",(function(){return vt})),
/* harmony export (binding) */n.d(e,"Bb",(function(){return yt}));const i="SHOW_CHECKIN_CAMERA_SIDEBAR",r="HIDE_CHECKIN_CAMERA_SIDEBAR",o="RESET_CHECKIN_IMAGES",s="SET_CHECKIN_KIT_IMAGES",c="ADD_CHECKIN_CHECKIN_IMAGE",a="REMOVE_CHECKIN_CHECKIN_IMAGE",u="SELECT_CHECKIN_CHECKIN_IMAGE",d="SELECT_CHECKIN_KIT_IMAGE",l="SHOW_CHECKIN_PRINT_DIALOG",E="HIDE_CHECKIN_PRINT_DIALOG",_="SHOW_CHECKIN_SERIAL_KIT_INFO_DIALOG",T="HIDE_CHECKIN_SERIAL_KIT_INFO_DIALOG",f="REPLACE_CHECKIN_PRODUCT",p="SHOW_CHECKIN_REPLACEMENT_DIALOG",h="HIDE_CHECKIN_REPLACEMENT_DIALOG",S="RESTORE_CHECKIN_PRODUCT",I="UNDO_CHECKIN_SERVICE",C="APPLY_CHECKIN_SERVICE_CHANGES",m="APPLY_CHECKIN_REASON",R="SET_CHECKIN_MISSING_QUANTITY",A="SET_CHECKIN_OPERATION_REASONS",O="SHOW_CHECKIN_SERVICE_PANEL",D="CHECKIN_SERVICE_PANEL_MODE",N="HIDE_CHECKIN_SERVICE_PANEL",b="SET_CHECKIN_KIT_LIST",L="SET_CHECKIN_KIT_GRIDS",g="SET_CHECKIN_SEALED_LIST",v="SET_CHECKIN_SEALED_ITEMS_LIST",y="SET_CHECKIN_SEALED_GRIDS",P="SET_CHECKIN_SELECTED_CUSTOMER_ORDER_ID",k="SET_CHECKIN_SELECTED_CUSTOMER_ORDER",w="SET_CHECKIN_CONTAINER_TYPE_CODE",M="SET_CHECKIN_SEALED_DETAIL",x="SET_CHECKIN_DETAIL_ROWS",G="SET_CHECKIN_SELECTED_SERIAL_KIT_ID",K="SET_CHECKIN_KIT_INFORMATION",U="SET_CHECKIN_KIT_CONTAINER_ROWS",B="SET_CHECKIN_KIT_ROWS",H="TOGGLE_CHECKIN_KIT_GROUP_DETAIL",$="TOGGLE_CHECKIN_KIT_GROUP_PARENT_SELECTED",W="SELECT_CHECKIN_ROW",j="SET_CHECKIN_KIT_ROWS_IMAGES",F="SELECT_CHECKIN_NEXT_ROW",V="PACK_CHECKIN_ROW",Y="DECREMENT_CHECKIN_CHECKED_ITEMS",z="INCREMENT_CHECKIN_CHECKED_ITEMS",q="SET_CHECKIN_TOTAL_ITEMS_COUNT",Q="SET_CHECKIN_CHECKED_ITEMS_COUNT",J="SET_CHECKIN_MOTHER_ENVELOPE_CAPACITY",X="SET_CHECKIN_MOTHER_ENVELOPE_REQUIRED",Z="EMPTY_CHECKIN_CHECKED_ITEM_COUNT",tt="EMPTY_CHECKIN_TOTAL_ITEM_COUNT",et="SHOW_CHECKIN_STER_DIALOG",nt="HIDE_CHECKIN_STER_DIALOG",it="SET_CHECKIN_COPIES",rt="CONFIRM_CHECKIN_SAVE",ot="UNSET_CHECKIN_SAVING",st="SET_CHECKIN_ADMITTED_EQUIPMENT_REASONS",ct="SET_CHECKIN_DEFAULT_LOANED_PRODUCT",at="SET_PACKAGE_SERIAL_KIT_IMAGE_LIST",ut="SET_PACKAGE_PRODUCT_IMAGE_LIST",dt="SET_PACKAGE_SERIAL_KIT_LAST_CYCLE_CODE",lt="SET_PACKAGE_KIT_REGISTRY_IMAGES",Et="SET_PACKAGE_SINGLE_PRODUCT_ATTACHMENT_LIST",_t="SET_PACKAGE_KIT_ATTACHMENT_LIST",Tt="SET_CHECKIN_KIT_TREE",ft="SET_SEALED_BLUBOX_FILTER",pt="SET_SIDEBAR_REPORT_ACTION",ht="SET_DEFAULT_STATE",St="SET_SERIAL_KIT_OPENED_PREVIOUSLY",It="SET_SIDEBAR_REPORT_ID",Ct="SET_VIEW_MODE",mt="SET_SELECTED_TAB",Rt=t=>({type:It,sidebarReportId:t}),At=t=>({type:w,containerTypeCode:t}),Ot=t=>({type:P,selectedCustomerOrderId:t}),Dt=t=>({type:J,motherEnvelopeCapacity:t}),Nt=t=>({type:X,motherEnvelopeRequired:t}),bt=()=>({type:ht}),Lt=t=>({type:ft,sealedBluBoxFilter:t}),gt=t=>({type:pt,sidebarReportAction:t}),vt=t=>({type:Ct,viewMode:t}),yt=t=>({type:mt,selectedTab:t})},
/***/cru0:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"c",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"f",(function(){return o})),
/* harmony export (binding) */n.d(e,"g",(function(){return s})),
/* harmony export (binding) */n.d(e,"h",(function(){return c})),
/* harmony export (binding) */n.d(e,"d",(function(){return a})),
/* harmony export (binding) */n.d(e,"b",(function(){return u})),
/* harmony export (binding) */n.d(e,"a",(function(){return d}));
/* unused harmony export setFixedGridManagementEnabled */
/* unused harmony export setKitList */
/* unused harmony export setKitListAlreadyAssociated */
/* unused harmony export setSealedList */
/* unused harmony export setSealedListAlreadyAssociated */
/* unused harmony export setItemSelected */
/* unused harmony export addGridToItemSelected */
/* unused harmony export removeGridToItemSelected */
const i="SET_GRIDASS_FIXED_GRID_MANAGEMENT_ENABLED",r="SET_GRIDASS_KIT_LIST",o="SET_GRIDASS_KIT_LIST_ALREADY_ASSOCIATED",s="SET_GRIDASS_SEALED_LIST",c="SET_GRDIASS_SEALED_LIST_ALREADY_ASSOCIATED",a="SET_GRIDASS_ITEM_SELECTED",u="DELETE_GRIDASS_GRID_TO_ITEM_SELECTED",d="ADD_GRIDASS_GRID_TO_ITEM_SELECTED"},
/***/"d+O/":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_DDT_DETAILS",r=t=>({type:i,ddts:t})
/***/},
/***/dVtU:
/***/function(t,e,n){"use strict";
// EXTERNAL MODULE: ./node_modules/lit-element/lit-element.js?babel-target=es6 + 5 modules
var i=n("Rukz"),r=n("afDP");
// EXTERNAL MODULE: ./styles/sixlm/styles.js?babel-target=es6 + 15 modules
n("ASvk"),n("JZ/u"),n("7eJ4");
// CONCATENATED MODULE: ./src/components/app-icons.js?babel-target=es6
i.d`
  <svg width="24" height="24" viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></svg>
`,i.d`
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></g>
  </svg>
`;const o=i.d`<svg viewBox="0 0 24 24"><g><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></path></g></svg>`;i.d`
  <svg width="36" height="36" viewBox="0 0 24 24">
    <g>
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
      />
    </g>
  </svg>
`,i.d`
  <svg viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    />
  </svg>
`,i.d`
  <svg viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
    />
  </svg>
`,i.d`
  <svg viewBox="0 0 24 24">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
`;
// CONCATENATED MODULE: ./src/components/search-input-decorator.js?babel-target=es6
class s extends i.b{static get styles(){return[r.v]}render(){const{_focused:t}=this;return i.d`
      <div class="icon">${o}</div>
      <div class="decorator" ?focused="${t}">
        <slot id="inputSlot" name="input"></slot>
      </div>
      <slot name="button"></slot>
    `}static get properties(){return{_focused:{type:Boolean}}}firstUpdated(){
// Do all setup work after the first render.
// Assume the input is in the slot
this._input=this.shadowRoot.querySelector("#inputSlot").assignedNodes({flatten:!0})[0],this._input.addEventListener("focus",()=>this._focused=!0),this._input.addEventListener("blur",()=>this._focused=!1)}}window.customElements.define("search-input-decorator",s);
// CONCATENATED MODULE: ./src/components/speech-mic.js?babel-target=es6
class c extends i.b{static get styles(){return[r.Bb]}render(){return i.d`
      <div class="ring1"></div>
      <div class="ring2"></div>
      <button title="Search by voice" @click="${()=>this.toggle()}">
        <svg viewBox="0 0 24 24">
          <g>
            <path
              d="M12,14c1.7,0,3-1.3,3-3l0-6c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v6C9,12.7,10.3,14,12,14z M17.3,11c0,3-2.5,5.1-5.3,5.1c-2.8,0-5.3-2.1-5.3-5.1H5c0,3.4,2.7,6.2,6,6.7V21h2v-3.3c3.3-0.5,6-3.3,6-6.7H17.3z"
            ></path>
          </g>
        </svg>
      </button>
    `}static get properties(){return{transcript:{type:String},completeTranscript:{type:String},language:{type:String},continuous:{type:Boolean},interimResults:{type:Boolean},_recognizing:{type:Boolean,attribute:"recognizing",reflect:!0}}}constructor(){super(),this.language=window.navigator.language}firstUpdated(){window.webkitSpeechRecognition?(this._recognition=new webkitSpeechRecognition,this._recognition.continuous=this.continuous,this._recognition.interimResults=this.interimResults,this._recognition.lang=this.language,this._recognition.onstart=this._onStart.bind(this),this._recognition.onend=this._onEnd.bind(this),this._recognition.onresult=this._onResult.bind(this),this._recognition.onerror=this._onError.bind(this)):this.style.display="none"}toggle(){this._recognition&&(this._recognizing?this._recognition.stop():this._recognition.start())}stop(){this._recognition&&this._recognition.stop()}_onStart(){this._recognizing=!0}_onEnd(){this._recognizing=!1}_onResult(t){let e,n,i="";for(let r,o=0;r=t.results[o];o++)e=r[0]&&r[0].transcript||"",i+=e,n=r.isFinal;this.transcript=e,this.completeTranscript=i,this.dispatchEvent(new CustomEvent("result",{detail:{results:t.results,transcript:e,completeTranscript:i,isFinal:n}})),n&&this.stop()}_onError(t){console.log(t)}}window.customElements.define("speech-mic",c);
// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js?babel-target=es6 + 1 modules
var a=n("4fQY");
// CONCATENATED MODULE: ./src/components/six-notification.js?babel-target=es6
class u extends i.b{static get styles(){return[]}render(){return this.showIcon?i.d` <six-title icon="bell" useFontawesome></six-title> `:a.f}static get properties(){return{notificationWebsocketUrl:{type:String},username:{type:String},role:{type:String},showIcon:{type:Boolean},workstationCode:{type:String}}}constructor(){super()}disconnectedCallback(){super.disconnectedCallback(),this.closeWebsocket(),clearInterval(this._interval)}updated(t){t.has("notificationWebsocketUrl")&&(this.notificationWebsocketUrl?this.openWebsocket():this.closeWebsocket()),this._websocket&&this._websocket.readyState==this._websocket.OPEN&&(t.has("username")||t.has("role")||t.has("workstationCode"))&&this._registerDefaultChannels()}
/*********************************************************************************** */openWebsocket(){if(!this.notificationWebsocketUrl)throw Error("url property is required");this.closeWebsocket(),//chiudo vecchia WS caso mai fosse aperta
this._websocket=new WebSocket(this.notificationWebsocketUrl),//url passato da app-steriliza
this._websocket.onopen=this._onOpen.bind(this),this._websocket.onclose=this._onClose.bind(this),this._websocket.onmessage=this._onMessage.bind(this),this._websocket.onerror=this._onError.bind(this),this._interval=setInterval(()=>{this._websocket&&this._websocket.readyState==this._websocket.OPEN&&(
//se è connected allora ping
this._websocket.send(JSON.stringify({type:"ping"})),// eslint-disable-next-line no-console
console.log("ping ws "+JSON.stringify(this._websocket)))},15e3)}closeWebsocket(){this._websocket&&(this._websocket.close(),this._websocket=null)}_onOpen(){this._registerDefaultChannels(),// eslint-disable-next-line no-console
console.log("Connection opened with websocket "+this.notificationWebsocketUrl)}_onClose(){
// eslint-disable-next-line no-console
console.log("Connection closed with websocket "+this.notificationWebsocketUrl)}_onError(){
// eslint-disable-next-line no-console
console.log("connection error"),this.closeWebsocket()}_onMessage(t){let e,n,i=JSON.parse(t.data);const r=new Promise((t,i)=>{e=t,n=i});if("ping"!=i.type){if("notifymessage"==i.type){const t=JSON.parse(i.metadata||null);if(t&&t.notificationTriggerUsername!==this.username)return}document.dispatchEvent(new CustomEvent("new-sx-message",{detail:{message:{type:i.level||"info",icon:{prefix:"fas",icon:i.icon},message:i.from+": "+i.msg,okButton:!0,okButtonText:"OK"},promise:{resolve:e,reject:n},data:i}})),r.then(t=>this.dispatchEvent(new CustomEvent("notification-read",{detail:{value:t}})))}}_registerDefaultChannels(){this.username&&this._websocket.send(JSON.stringify({project:this.username})),this.role&&this._websocket.send(JSON.stringify({project:this.role})),this.workstationCode&&this._websocket.send(JSON.stringify({project:"notify_"+this.workstationCode}))}}window.customElements.define("six-notification",u);
// EXTERNAL MODULE: ./src/components/six-tooltip-content.js?babel-target=es6
n("jrL5"),n("SMGt");
// EXTERNAL MODULE: ./node_modules/fontawesome-icon/fontawesome-icon.js?babel-target=es6
var d=n("jimv"),l=n("hroh"),E=n("yEz4"),_=n("DQGw"),T=n("XG6N"),f=n("vcFs"),p=n("bZUI");
// CONCATENATED MODULE: ./src/components/top-bar.js?babel-target=es6
class h extends i.b{static get styles(){return[r.a,r.Db,i.c`
        .message-item {
          border-top: none !important;
          border-bottom: 1px dashed #2c3f63 !important;
        }
        .message-item fontawesome-icon {
          flex-grow: 0;
          padding-right: 5px;
          font-size: 11px;
        }
        .dropdown-content {
          width: 400px;
          height: 300px;
          overflow-y: auto;
        }
        .dr-complaint {
          background: #fd9c86;
          padding: 0 10px;
          border-radius: 5px;
          border: none;
        }
        .dr {
          background: #fff;
          padding: 0 10px;
          border-radius: 5px;
          border: none;
        }
        .version-num {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: small;
          color: #888888;
          font-style: italic;
          padding-top: 7px;
          max-width: 280px;
        }
      `]}render(){return i.d`
      <app-header condenses fixed effects="waterfall">
        <app-toolbar class="toolbar-top" .style="${this.pwaMode?"":"display: none;"}">
          <a @click="${this._buttonClicked}"><fontawesome-icon prefix="fas" name="bars"></fontawesome-icon></a>
          <div class="toolbar-top-logo">
            <img src="${l.a}" alt="${this.appTitle}" title="${this.appTitle}" @click="${this._buttonClicked}" />
          </div>
          ${this._buildNum?i.d` <b class="version-num"> ${this._buildNum} </b> `:a.f}
          ${"xyz"!==this.page?i.d`
                <search-input-decorator top>
                  <input
                    autocomplete="off"
                    slot="input"
                    id="inputSearch"
                    aria-label="${Object(d.a)("COMMON.SEARCH")}"
                    type="search"
                    list="menulist"
                    @change="${t=>this._onSearchInputChanged(t)}"
                  />
                  <datalist id="menulist"> </datalist>
                  <speech-mic slot="button" continuous interimResults @result="${t=>this._result(t)}"></speech-mic>
                </search-input-decorator>
              `:i.d`
                <six-code-reader
                  label=""
                  buttonLabel="${"COMMON.BARCODE"}"
                  placeholder="${"COMMON.BARCODE"}"
                  id="codeReaderElement"
                  milliseconds
                  top
                ></six-code-reader>
              `}
          ${this.notificationsCount?i.d` <div class="workstation">
                <div class="dropdown dr">
                  <six-title
                    color="${"rekeep"!=f.a?"":"white"}"
                    @click="${this._goToMessages}"
                    class="topbar-title blue truncate"
                    icon="bell"
                    label="${this.notificationsCount}"
                    useFontawesome
                  ></six-title>
                  <div class="dropdown-content">
                    <ul>
                      ${this.notifications&&this.notifications.length?this.notifications.map(t=>i.d` <li class="message-item">
                              <div @click="${()=>_.a.dispatch(Object(E.c)("message/handle/"+t.process_instance_id))}" style="display: flex;">
                                <fontawesome-icon prefix="fas" name="envelope"></fontawesome-icon>
                                <div style="flex-grow: 1;"><strong>${t.lastSender.toUpperCase()}</strong>: ${t.lastMessage}</div>
                              </div>
                            </li>`):a.f}
                    </ul>
                  </div>
                </div>
              </div>`:""}
          ${this.complaintsCount?i.d` <div class="workstation">
                <div class="dropdown dr-complaint">
                  <six-title
                    color="${"rekeep"!=f.a?"":"white"}"
                    @click="${this._goToMessages}"
                    class="topbar-title blue truncate"
                    icon="exclamation-triangle"
                    label="${this.complaintsCount}"
                    useFontawesome
                  ></six-title>
                  <div class="dropdown-content">
                    <ul>
                      ${this.complaints&&this.complaints.length?this.complaints.map(t=>i.d` <li class="message-item">
                              <div @click="${()=>_.a.dispatch(Object(E.c)("ticket/handle/"+t.taskId))}">
                                <div style="display: flex; justify-content: space-between; align-items:flex-start; align-content:flex-start;">
                                  <div style="display: flex;">
                                    <fontawesome-icon prefix="fas" name="exclamation-triangle"></fontawesome-icon>
                                    <strong>${t.lastSender.toUpperCase()}</strong>
                                  </div>
                                  <span style="flex-grow: 0; background: #FFF; border-radius: 3px; padding: 0px 3px; color: #253655; align-self:flex-start;"
                                    >${Object(d.a)("COMMON."+t.status)}</span
                                  >
                                </div>
                                <div class="complaint-message">${t.lastMessage}</div>
                                <div style="text-align: right; font-style: italic; font-size: 10px;">
                                  ${t.customer_description} ${t.destination_description}
                                </div>
                              </div>
                            </li>`):a.f}
                    </ul>
                  </div>
                </div>
              </div>`:""}
          ${this.showUnderstockPercentageAlert&&this._checkDestinationsUnderstockPercentage?i.d`
                <div class="workstation">
                  <div
                    class="dropdown animate-pulse rounded border border-red-700 flex px-1"
                    style="padding: 0;font-size: 15px;background-color: var(--app-danger-color)"
                    @click="${()=>_.a.dispatch(Object(E.c)("destination-understock-report"))}"
                  >
                    <fontawesome-icon class="px-1 text-white" name="exclamation-triangle"></fontawesome-icon>
                    <p class="text-xs pr-1"><i>${Object(d.a)("COMMON.UNDERSTOCK").toLowerCase()}</i></p>
                  </div>
                </div>
              `:a.f}

          <div class="workstation">
            <div class="dropdown">
              <six-notification
                @notification-read=${this._onNotification}
                .username="${this.username.user}"
                .role="${this.role}"
                .notificationWebsocketUrl="${this.notificationWebsocketUrl}"
                .workstationCode="${this.workstationCode}"
              ></six-notification>
            </div>
          </div>

          <div class="workstation">
            <div class="dropdown">
              <six-title
                color="${"rekeep"!=f.a?"":"white"}"
                title="${this.workstationCode}"
                class="topbar-title truncate "
                @click="${this._connectCurrentWs}"
                .color="${this._getWsStatusColor()}"
                icon="barcode"
                label="${this.workstationCode}"
                useFontawesome
              ></six-title>
            </div>
          </div>

          <div class="workstation">
            <div class="dropdown">
              <six-title
                color="${"rekeep"!=f.a?"":"white"}"
                class="topbar-title truncate"
                title="${this.company.company} - ${this.company.division}"
                icon="home"
                label="${this.company.company} - ${this.company.division}"
                useFontawesome
              ></six-title>
            </div>
          </div>

          <div class="workstation">
            <div class="dropdown">
              <six-title
                color="${"rekeep"!=f.a?"":"white"}"
                title="${this.role}"
                class="topbar-title truncate"
                icon="id-card"
                label="${this.role}"
                useFontawesome
              ></six-title>
            </div>
          </div>

          <div class="user">
            <div class="dropdown">
              <six-title
                color="${"rekeep"!=f.a?"":"white"}"
                title="${this.username.name||""} ${this.username.surname||""} (${this.username.user})"
                class="topbar-title truncate"
                icon="user"
                label="${this.username.name||""} ${this.username.surname||""} (${this.username.user})"
                useFontawesome
              ></six-title>
              <div class="dropdown-content">
                <ul>
                  ${this.advancedMenu?i.d`
                        <li>
                          <div @click="${()=>this._onMenuVoiceClick("admin",!0)}"><i class="fa fa-sign-out"></i>${Object(d.a)("COMMON.ADMIN")}</div>
                        </li>
                      `:a.f}
                  <li>
                    <div @click="${()=>this._onMenuVoiceClick("preferences",!0)}"><i class="fa fa-sign-out"></i>${Object(d.a)("COMMON.PREFERENCES")}</div>
                  </li>
                  <li>
                    <div @click="${()=>this._onMenuVoiceClick("logout",!0)}"><i class="fa fa-sign-out"></i>${Object(d.a)("COMMON.LOGOUT")}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <fontawesome-icon
            @click="${()=>this._onMenuVoiceClick("logout",!0)}"
            style="cursor:pointer; color: var(--logout-btn-color)"
            name="power-off"
            prefix="fas"
            fixed-width
          ></fontawesome-icon>
        </app-toolbar>

        <!-- This gets hidden on a small screen-->
      </app-header>
    `}static get properties(){return{page:{type:String},bookmarks:{type:Array},workstationCode:{type:String},username:{type:Object},pwaMode:{type:Boolean},appTitle:{type:String},menu:{type:Array},advancedMenu:{type:Boolean},company:{type:Object},notificationWebsocketUrl:{type:String},role:{type:String},notificationsCount:{type:Number},notifications:{type:Array},complaints:{type:Array},complaintsCount:{type:Number},websocketStatus:{type:String},showUnderstockPercentageAlert:{type:Boolean},_buildNum:{attribute:!1},_checkDestinationsUnderstockPercentage:{attribute:!1}}}constructor(){super(),this.notificationsCount=0,this.notifications=[],this.websocketStatus="",this.showUnderstockPercentageAlert=!1}firstUpdated(){this._flattenMenu=this._flatten(this.menu),this._api=new T.a,this._api.getBuildNum().then(t=>this._buildNum=null==t?void 0:t.value)}updated(t){t.has("menu")&&(this._menuList=this._flattenMenu.sort((t,e)=>{let n=(t.title||"").toUpperCase(),i=(e.title||"").toUpperCase();return n<i?-1:n>i?1:0}),this._resetSearchBarDataList(this._menuList)),t.has("showUnderstockPercentageAlert")&&this.showUnderstockPercentageAlert&&(this._searchForUndestockDestinations(),setInterval(()=>this._searchForUndestockDestinations(),9e5))}
/******************************************************************* */closeWebsocket(){this.shadowRoot.querySelector("six-notification").closeWebsocket()}_flatten(t){const e=[],n=t=>{t.forEach(t=>{t.children&&t.children.length?n(t.children):e.push({page:t.code,title:t.description})})};return n(t),e}_autocomplete(t){let e=t.target,n=this.shadowRoot.querySelector("#menulist");n.innerHTML="",this._menuList.filter(t=>t.title.toLowerCase().indexOf(e.value.toLowerCase())>-1).forEach(t=>{const e=document.createElement("option");e.value=t.title,e.page=t.page,n.appendChild(e)})}_onSearchInputChanged(){let t=this.shadowRoot.querySelector("#inputSearch").value,e=this.shadowRoot.querySelector(`#menulist option[value="${t}"]`),n=e&&e.page||t;this.shadowRoot.querySelector("#inputSearch").value="",this.shadowRoot.querySelector("#inputSearch").blur(),this._resetSearchBarDataList(this._menuList),this.dispatchEvent(new CustomEvent("changeSearch",{detail:{value:n}}))}_resetSearchBarDataList(t){let e=this.shadowRoot.querySelector("#menulist");e.innerHTML="";for(let n=0;n<t.length;n++){
// rendering più veloce dei risultati, testato
const i=t[n],r=document.createElement("option");r.value=i.title,r.page=i.page,e.appendChild(r)}}_onMenuVoiceClick(t,e){this.dispatchEvent(new CustomEvent("menuVoiceClick",{detail:{key:t,value:e}}))}_buttonClicked(){this.dispatchEvent(new CustomEvent("buttonClicked",{detail:{value:!0}}))}_result(t){this.dispatchEvent(new CustomEvent("result",{detail:{value:t}}))}_onNotification(t){this.dispatchEvent(new CustomEvent("notification-read",{detail:{value:t.detail.value}}))}_goToMessages(){_.a.dispatch(Object(E.c)("message/list"))}_getWsStatusColor(){let t="";switch(this.websocketStatus){case"OPEN":t="var(--app-success-color)";break;case"CLOSE":default:t="var(--app-danger-color)"}return t}_connectCurrentWs(){this.dispatchEvent(new CustomEvent("reconnectWebSocket",{detail:{value:!0}}))}_searchForUndestockDestinations(){
/* client
      .watchQuery({
        query: gql`
          query boh {
            destination_understock_report_aggregate(where: { understock: { _eq: "T" } }) {
              aggregate {
                count
              }
            }
          }
        `,
      })
      .subscribe({
        next: (data) => {
          console.log(data);
        }
        error: (e) => console.error(e),
      }); */
let t=[{kind:"number",column:"t.current_stock_percentage",relation:"<",value:"t.understock_percentage"}];(Object(p.k)(_.a.getState())||[]).length>0&&(t=[...t,{column:"customer_destination_user cdu",relation:"JOIN",value:"t.customer_destination_id = cdu.customer_destination_id"},{column:"users u",relation:"JOIN",value:"cdu.user_id = u.id"},{column:"u.username",kind:"string",relation:"=",value:""+Object(p.c)(_.a.getState())}]),this._api.getDestinationUnderstockReport(1,1,"",t).then(t=>this._checkDestinationsUnderstockPercentage=t.totalResults>0)}}window.customElements.define("top-bar",h)},
/***/dg1p:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_SHIPMENT_WARD_DETAIL",r=(t,e,n,r)=>({type:i,customerDestinationId:t,componentProcessed:e,chipMap:n,noChipMap:r})
/***/},
/***/"e/Wx":
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"c",(function(){return i})),
/* harmony export (binding) */n.d(e,"d",(function(){return r})),
/* harmony export (binding) */n.d(e,"f",(function(){return o})),
/* harmony export (binding) */n.d(e,"e",(function(){return s})),
/* harmony export (binding) */n.d(e,"a",(function(){return c})),
/* harmony export (binding) */n.d(e,"b",(function(){return a})),
/* unused harmony export setTrackingBarcodeProcessPage */
/* harmony export (binding) */n.d(e,"j",(function(){return u})),
/* harmony export (binding) */n.d(e,"k",(function(){return d})),
/* harmony export (binding) */n.d(e,"i",(function(){return l})),
/* harmony export (binding) */n.d(e,"h",(function(){return E})),
/* harmony export (binding) */n.d(e,"g",(function(){return _}));const i="SET_TRACKINGBARCODEPROCESS_PAGE",r="SET_TRACKINGBARCODEPROCESS_SELECTED_KIT_STATUS_HISTORY",o="SET_TRACKINGBARCODE_STATUS_LIST_BARCODE",s="SET_TRACKINGBARCODEPROCESS_SERIAL_KIT_LIST",c="SET_TRACKINGBARCODEPROCESS_ACTIVE_GRID_FILTERS",a="SET_TRACKINGBARCODEPROCESS_ACTIVE_GRID_PAGE",u=t=>({type:r,kitStatusHistory:t}),d=t=>({type:o,statusList:t}),l=t=>({type:s,kitList:t}),E=t=>({type:c,filters:t}),_=t=>({type:a,page:t})},
/***/eVfm:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"g",(function(){return i})),
/* harmony export (binding) */n.d(e,"j",(function(){return r})),
/* harmony export (binding) */n.d(e,"k",(function(){return o})),
/* harmony export (binding) */n.d(e,"l",(function(){return s})),
/* harmony export (binding) */n.d(e,"m",(function(){return c})),
/* harmony export (binding) */n.d(e,"n",(function(){return a})),
/* harmony export (binding) */n.d(e,"a",(function(){return u})),
/* harmony export (binding) */n.d(e,"d",(function(){return d})),
/* harmony export (binding) */n.d(e,"b",(function(){return l})),
/* harmony export (binding) */n.d(e,"c",(function(){return E})),
/* harmony export (binding) */n.d(e,"o",(function(){return _})),
/* harmony export (binding) */n.d(e,"i",(function(){return T})),
/* harmony export (binding) */n.d(e,"h",(function(){return f})),
/* harmony export (binding) */n.d(e,"f",(function(){return p})),
/* harmony export (binding) */n.d(e,"e",(function(){return h})),
/* harmony export (binding) */n.d(e,"q",(function(){return S})),
/* harmony export (binding) */n.d(e,"p",(function(){return I})),
/* harmony export (binding) */n.d(e,"r",(function(){return C})),
/* harmony export (binding) */n.d(e,"s",(function(){return m}));
/* unused harmony export setCarts */
/* unused harmony export setEquipments */
/* unused harmony export setProductiveReasons */
/* unused harmony export setSelectedCart */
/* unused harmony export setSelectedEquipment */
/* unused harmony export setSelectedProductiveReason */
/* unused harmony export setSelectedProdOrderId */
/* unused harmony export initDetailStep */
/* unused harmony export restoreDetailStep */
/* unused harmony export nextDetailStep */
/* unused harmony export prevDetailStep */
/* unused harmony export setSpecificDetailStep */
/* unused harmony export setElementsToLoading */
/* unused harmony export setElementsLoaded */
/* unused harmony export setBoxContainersToLoading */
/* unused harmony export setBoxContainersLoaded */
/* unused harmony export setWashcartError */
/* unused harmony export setWashEquipmentConfirmDialog */
/* unused harmony export setWashCartToggleReloadData */
const i="SET_CARTS",r="SET_EQUIPMENTS",o="SET_PRODUCTIVE_REASONS",s="SET_SELECTED_CART",c="SET_SELECTED_EQUIPMENT",a="SET_SELECTED_PRODUCTIVE_REASON",u="INIT_DETAIL_STEP",d="RESTORE_DETAIL_STEP",l="NEXT_DETAIL_STEP",E="PREVIOUS_DETAIL_STEP",_="SET_SPECIFIC_DETAIL_STEP",T="SET_ELEMENTS_TO_LOADING",f="SET_ELEMENTS_LOADED",p="SET_BOX_CONTAINERS_TO_LOADING",h="SET_BOX_CONTAINERS_LOADED",S="SET_WASHCART_SELECTED_PROD_ORDER_ID",I="SET_WASHCART_ERROR",C="SET_WASHCART_SHOW_EQUIPMENT_CONFIRM_DIALOG",m="SET_WASHCART_TOGGLE_RELOAD_DATA"},
/***/ea9N:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"c",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"f",(function(){return s})),
/* harmony export (binding) */n.d(e,"d",(function(){return c})),
/* harmony export (binding) */n.d(e,"e",(function(){return a}));const i="SET_RETURNDDT_SELECTED_DESTINATION",r="SET_RETURNDDT_ROWS",o="SET_RETURNDDT_SELECTED_DDT",s=t=>({type:i,selectedDestination:t}),c=t=>({type:r,rows:t}),a=t=>({type:o,selectedDdt:t})},
/***/ezc7:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));
/* unused harmony export setMaintenanceCreatedDdt */
/* unused harmony export setMaintenanceSelectedSupplierId */
const i="SET_MAINTENANCE_CREATED_DDT",r="SET_MAINTENANCE_SELECTED_SUPPLIER_ID"},
/***/fbHz:
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=n("afDP");
/* harmony import */class o extends i.b{static get properties(){return{active:{type:Boolean}}}static get styles(){return[r.Ab]}render(){return i.d`
      <slot></slot>
    `}}window.customElements.define("snack-bar",o)},
/***/ff2w:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"fb",(function(){return i})),
/* harmony export (binding) */n.d(e,"h",(function(){return r})),
/* harmony export (binding) */n.d(e,"s",(function(){return o})),
/* harmony export (binding) */n.d(e,"M",(function(){return s})),
/* harmony export (binding) */n.d(e,"a",(function(){return c})),
/* harmony export (binding) */n.d(e,"q",(function(){return a})),
/* harmony export (binding) */n.d(e,"w",(function(){return u})),
/* harmony export (binding) */n.d(e,"u",(function(){return d})),
/* harmony export (binding) */n.d(e,"gb",(function(){return l})),
/* harmony export (binding) */n.d(e,"i",(function(){return E})),
/* harmony export (binding) */n.d(e,"ib",(function(){return _})),
/* harmony export (binding) */n.d(e,"k",(function(){return T})),
/* harmony export (binding) */n.d(e,"r",(function(){return f})),
/* harmony export (binding) */n.d(e,"hb",(function(){return p})),
/* harmony export (binding) */n.d(e,"j",(function(){return h})),
/* harmony export (binding) */n.d(e,"t",(function(){return S})),
/* harmony export (binding) */n.d(e,"nb",(function(){return I})),
/* harmony export (binding) */n.d(e,"c",(function(){return C})),
/* harmony export (binding) */n.d(e,"b",(function(){return m})),
/* harmony export (binding) */n.d(e,"S",(function(){return R})),
/* harmony export (binding) */n.d(e,"V",(function(){return A})),
/* harmony export (binding) */n.d(e,"jb",(function(){return O})),
/* harmony export (binding) */n.d(e,"o",(function(){return D})),
/* harmony export (binding) */n.d(e,"l",(function(){return N})),
/* harmony export (binding) */n.d(e,"O",(function(){return b})),
/* harmony export (binding) */n.d(e,"L",(function(){return L})),
/* harmony export (binding) */n.d(e,"Z",(function(){return g})),
/* harmony export (binding) */n.d(e,"Y",(function(){return v})),
/* harmony export (binding) */n.d(e,"X",(function(){return y})),
/* harmony export (binding) */n.d(e,"bb",(function(){return P})),
/* harmony export (binding) */n.d(e,"ab",(function(){return k})),
/* harmony export (binding) */n.d(e,"G",(function(){return w})),
/* harmony export (binding) */n.d(e,"W",(function(){return M})),
/* harmony export (binding) */n.d(e,"J",(function(){return x})),
/* harmony export (binding) */n.d(e,"cb",(function(){return G})),
/* harmony export (binding) */n.d(e,"N",(function(){return K})),
/* harmony export (binding) */n.d(e,"K",(function(){return U})),
/* harmony export (binding) */n.d(e,"P",(function(){return B})),
/* harmony export (binding) */n.d(e,"lb",(function(){return H})),
/* harmony export (binding) */n.d(e,"mb",(function(){return $})),
/* harmony export (binding) */n.d(e,"x",(function(){return W})),
/* harmony export (binding) */n.d(e,"Q",(function(){return j})),
/* harmony export (binding) */n.d(e,"v",(function(){return F})),
/* harmony export (binding) */n.d(e,"p",(function(){return V})),
/* harmony export (binding) */n.d(e,"e",(function(){return Y})),
/* harmony export (binding) */n.d(e,"n",(function(){return z})),
/* harmony export (binding) */n.d(e,"eb",(function(){return q})),
/* harmony export (binding) */n.d(e,"F",(function(){return Q})),
/* harmony export (binding) */n.d(e,"T",(function(){return J})),
/* harmony export (binding) */n.d(e,"U",(function(){return X})),
/* harmony export (binding) */n.d(e,"f",(function(){return Z})),
/* harmony export (binding) */n.d(e,"g",(function(){return tt})),
/* harmony export (binding) */n.d(e,"kb",(function(){return et})),
/* harmony export (binding) */n.d(e,"m",(function(){return nt})),
/* harmony export (binding) */n.d(e,"H",(function(){return it})),
/* harmony export (binding) */n.d(e,"d",(function(){return rt})),
/* harmony export (binding) */n.d(e,"ob",(function(){return ot})),
/* harmony export (binding) */n.d(e,"E",(function(){return st})),
/* harmony export (binding) */n.d(e,"I",(function(){return ct})),
/* harmony export (binding) */n.d(e,"B",(function(){return at})),
/* harmony export (binding) */n.d(e,"A",(function(){return ut})),
/* harmony export (binding) */n.d(e,"C",(function(){return dt})),
/* harmony export (binding) */n.d(e,"z",(function(){return lt})),
/* harmony export (binding) */n.d(e,"D",(function(){return Et})),
/* harmony export (binding) */n.d(e,"y",(function(){return _t})),
/* harmony export (binding) */n.d(e,"R",(function(){return Tt})),
/* harmony export (binding) */n.d(e,"db",(function(){return ft})),
/* harmony export (binding) */n.d(e,"sc",(function(){return pt})),
/* harmony export (binding) */n.d(e,"vb",(function(){return ht})),
/* harmony export (binding) */n.d(e,"Jb",(function(){return St})),
/* harmony export (binding) */n.d(e,"ac",(function(){return It})),
/* harmony export (binding) */n.d(e,"rb",(function(){return Ct})),
/* harmony export (binding) */n.d(e,"yc",(function(){return mt})),
/* harmony export (binding) */n.d(e,"Mb",(function(){return Rt})),
/* harmony export (binding) */n.d(e,"Cb",(function(){return At})),
/* unused harmony export showSterDialog */
/* unused harmony export hideSterDialog */
/* harmony export (binding) */n.d(e,"uc",(function(){return Ot})),
/* harmony export (binding) */n.d(e,"xb",(function(){return Dt})),
/* harmony export (binding) */n.d(e,"vc",(function(){return Nt})),
/* harmony export (binding) */n.d(e,"yb",(function(){return bt})),
/* harmony export (binding) */n.d(e,"tc",(function(){return Lt})),
/* harmony export (binding) */n.d(e,"wb",(function(){return gt})),
/* harmony export (binding) */n.d(e,"Eb",(function(){return vt})),
/* harmony export (binding) */n.d(e,"xc",(function(){return yt})),
/* unused harmony export applyServiceChanges */
/* harmony export (binding) */n.d(e,"qb",(function(){return Pt})),
/* unused harmony export setMissingQuantity */
/* harmony export (binding) */n.d(e,"Zb",(function(){return kt})),
/* harmony export (binding) */n.d(e,"Ab",(function(){return wt})),
/* harmony export (binding) */n.d(e,"sb",(function(){return Mt})),
/* harmony export (binding) */n.d(e,"Bb",(function(){return xt})),
/* harmony export (binding) */n.d(e,"Gb",(function(){return Gt})),
/* harmony export (binding) */n.d(e,"wc",(function(){return Kt})),
/* harmony export (binding) */n.d(e,"qc",(function(){return Ut})),
/* harmony export (binding) */n.d(e,"zb",(function(){return Bt})),
/* harmony export (binding) */n.d(e,"Lb",(function(){return Ht})),
/* harmony export (binding) */n.d(e,"Ub",(function(){return $t})),
/* harmony export (binding) */n.d(e,"Pb",(function(){return Wt})),
/* harmony export (binding) */n.d(e,"lc",(function(){return jt})),
/* harmony export (binding) */n.d(e,"mc",(function(){return Ft})),
/* harmony export (binding) */n.d(e,"kc",(function(){return Vt})),
/* harmony export (binding) */n.d(e,"oc",(function(){return Yt})),
/* harmony export (binding) */n.d(e,"nc",(function(){return zt})),
/* harmony export (binding) */n.d(e,"jc",(function(){return qt})),
/* harmony export (binding) */n.d(e,"Nb",(function(){return Qt})),
/* harmony export (binding) */n.d(e,"pc",(function(){return Jt})),
/* harmony export (binding) */n.d(e,"Tb",(function(){return Xt})),
/* harmony export (binding) */n.d(e,"Ob",(function(){return Zt})),
/* harmony export (binding) */n.d(e,"Vb",(function(){return te})),
/* harmony export (binding) */n.d(e,"ic",(function(){return ee})),
/* harmony export (binding) */n.d(e,"Qb",(function(){return ne})),
/* harmony export (binding) */n.d(e,"Rb",(function(){return ie})),
/* harmony export (binding) */n.d(e,"Wb",(function(){return re})),
/* harmony export (binding) */n.d(e,"Sb",(function(){return oe})),
/* harmony export (binding) */n.d(e,"pb",(function(){return se})),
/* unused harmony export removePackagingImage */
/* harmony export (binding) */n.d(e,"Fb",(function(){return ce})),
/* harmony export (binding) */n.d(e,"Hb",(function(){return ae})),
/* harmony export (binding) */n.d(e,"Db",(function(){return ue})),
/* harmony export (binding) */n.d(e,"Ib",(function(){return de})),
/* harmony export (binding) */n.d(e,"rc",(function(){return le})),
/* harmony export (binding) */n.d(e,"Kb",(function(){return Ee})),
/* harmony export (binding) */n.d(e,"Xb",(function(){return _e})),
/* harmony export (binding) */n.d(e,"Yb",(function(){return Te})),
/* harmony export (binding) */n.d(e,"ub",(function(){return fe})),
/* harmony export (binding) */n.d(e,"tb",(function(){return pe})),
/* harmony export (binding) */n.d(e,"ec",(function(){return he})),
/* harmony export (binding) */n.d(e,"dc",(function(){return Se})),
/* harmony export (binding) */n.d(e,"fc",(function(){return Ie})),
/* harmony export (binding) */n.d(e,"cc",(function(){return Ce})),
/* harmony export (binding) */n.d(e,"gc",(function(){return me})),
/* harmony export (binding) */n.d(e,"bc",(function(){return Re})),
/* harmony export (binding) */n.d(e,"hc",(function(){return Ae}));const i="SHOW_PACKAGING_CAMERA_SIDEBAR",r="HIDE_PACKAGING_CAMERA_SIDEBAR",o="RESET_PACKAGING_IMAGES",s="SET_PACKAGING_KIT_IMAGES",c="ADD_PACKAGING_PACKAGING_IMAGE",a="REMOVE_PACKAGING_PACKAGING_IMAGE",u="SELECT_PACKAGING_PACKAGING_IMAGE",d="SELECT_PACKAGING_KIT_IMAGE",l="SHOW_PACKAGING_PRINT_DIALOG",E="HIDE_PACKAGING_PRINT_DIALOG",_="SHOW_PACKAGING_SERIAL_KIT_INFO_DIALOG",T="HIDE_PACKAGING_SERIAL_KIT_INFO_DIALOG",f="REPLACE_PACKAGING_PRODUCT",p="SHOW_PACKAGING_REPLACEMENT_DIALOG",h="HIDE_PACKAGING_REPLACEMENT_DIALOG",S="RESTORE_PACKAGING_PRODUCT",I="UNDO_PACKAGING_SERVICE",C="APPLY_PACKAGING_SERVICE_CHANGES",m="APPLY_PACKAGING_REASON",R="SET_PACKAGING_MISSING_QUANTITY",A="SET_PACKAGING_OPERATION_REASONS",O="SHOW_PACKAGING_SERVICE_PANEL",D="PACKAGING_SERVICE_PANEL_MODE",N="HIDE_PACKAGING_SERVICE_PANEL",b="SET_PACKAGING_KIT_LIST",L="SET_PACKAGING_KIT_GRIDS",g="SET_PACKAGING_SEALED_LIST",v="SET_PACKAGING_SEALED_ITEMS_LIST",y="SET_PACKAGING_SEALED_GRIDS",P="SET_PACKAGING_SELECTED_CUSTOMER_ORDER_ID",k="SET_PACKAGING_SELECTED_CUSTOMER_ORDER",w="SET_PACKAGING_CONTAINER_TYPE_CODE",M="SET_PACKAGING_SEALED_DETAIL",x="SET_PACKAGING_DETAIL_ROWS",G="SET_PACKAGING_SELECTED_SERIAL_KIT_ID",K="SET_PACKAGING_KIT_INFORMATION",U="SET_PACKAGING_KIT_CONTAINER_ROWS",B="SET_PACKAGING_KIT_ROWS",H="TOGGLE_PACKAGING_KIT_GROUP_DETAIL",$="TOGGLE_PACKAGING_KIT_GROUP_PARENT_SELECTED",W="SELECT_PACKAGING_ROW",j="SET_PACKAGING_KIT_ROWS_IMAGES",F="SELECT_PACKAGING_NEXT_ROW",V="PACK_PACKAGING_ROW",Y="DECREMENT_PACKAGING_CHECKED_ITEMS",z="INCREMENT_PACKAGING_CHECKED_ITEMS",q="SET_PACKAGING_TOTAL_ITEMS_COUNT",Q="SET_PACKAGING_CHECKED_ITEMS_COUNT",J="SET_PACKAGING_MOTHER_ENVELOPE_CAPACITY",X="SET_PACKAGING_MOTHER_ENVELOPE_REQUIRED",Z="EMPTY_PACKAGING_CHECKED_ITEM_COUNT",tt="EMPTY_PACKAGING_TOTAL_ITEM_COUNT",et="SHOW_PACKAGING_STER_DIALOG",nt="HIDE_PACKAGING_STER_DIALOG",it="SET_PACKAGING_COPIES",rt="CONFIRM_PACKAGING_SAVE",ot="UNSET_PACKAGING_SAVING",st="SET_PACKAGING_ADMITTED_EQUIPMENT_REASONS",ct="SET_PACKAGING_DEFAULT_LOANED_PRODUCT",at="SET_PACKAGE_SERIAL_KIT_IMAGE_LIST",ut="SET_PACKAGE_PRODUCT_IMAGE_LIST",dt="SET_PACKAGE_SERIAL_KIT_LAST_CYCLE_CODE",lt="SET_PACKAGE_KIT_REGISTRY_IMAGES",Et="SET_PACKAGE_SINGLE_PRODUCT_ATTACHMENT_LIST",_t="SET_PACKAGE_KIT_ATTACHMENT_LIST",Tt="SET_PACKAGING_KIT_TREE",ft="SET_PACKAGING_SELECTED_TAB",pt=()=>({type:i}),ht=()=>({type:r}),St=t=>({type:st,list:t}),It=t=>({type:ct,defaultLoanedProduct:t}),Ct=t=>({type:rt,copies:t}),mt=()=>({type:ot}),Rt=t=>({type:it,copies:t}),At=t=>({type:f,selectedItem:t}),Ot=()=>({type:p}),Dt=()=>({type:h}),Nt=({onClose:t}={})=>({type:_,onClose:t}),bt=()=>({type:T}),Lt=()=>({type:l}),gt=()=>({type:E}),vt=t=>({type:S,reasonId:t}),yt=()=>({type:I}),Pt=t=>({type:m,reasonId:t}),kt=t=>({type:A,operationReasons:t}),wt=()=>({type:z}),Mt=()=>({type:Y}),xt=t=>({type:V,row:t}),Gt=()=>({type:F}),Kt=()=>({type:O}),Ut=t=>({type:D,servicePanelMode:t}),Bt=()=>({type:N}),Ht=t=>({type:w,containerTypeCode:t}),$t=t=>({type:b,kitList:t}),Wt=t=>({type:L,kitGrids:t}),jt=t=>({type:v,sealedItemsList:t}),Ft=t=>({type:g,sealedList:t}),Vt=t=>({type:y,sealedGrids:t}),Yt=t=>({type:P,selectedCustomerOrderId:t}),zt=t=>({type:k,selectedCustomerOrder:t}),qt=t=>({type:M,sealedDetail:t}),Qt=t=>({type:x,detailRows:t}),Jt=t=>({type:G,selectedSerialKitId:t}),Xt=t=>({type:K,serialKitInformation:t}),Zt=t=>({type:U,kitContainerRows:t}),te=t=>({type:B,kitRows:t}),ee=t=>({type:Tt,packagingKitTree:t}),ne=t=>({type:H,groupDetailOpened:t}),ie=t=>({type:$,groupParentSelected:t}),re=t=>({type:j,rowsImages:t}),oe=t=>({type:s,kitImages:t}),se=t=>({type:c,imageInfo:t}),ce=t=>({type:d,image:t}),ae=t=>({type:u,image:t}),ue=()=>({type:o}),de=t=>({type:W,kitRow:t}),le=t=>({type:q,totalItemsCount:t||0}),Ee=t=>({type:Q,checkedItemsCount:t}),_e=t=>({type:J,motherEnvelopeCapacity:t}),Te=t=>({type:X,motherEnvelopeRequired:t}),fe=()=>({type:tt}),pe=()=>({type:Z}),he=t=>({type:at,packageSerialKitImageList:t}),Se=t=>({type:ut,packageProductImageList:t}),Ie=t=>({type:dt,packageSerialKitLastCycleCode:t}),Ce=t=>({type:lt,packageKitRegistryImages:t}),me=t=>({type:Et,packageSingleProductAttachmentsList:t}),Re=t=>({type:_t,packageKitAttachmentsList:t}),Ae=t=>({type:ft,selectedTab:t})},
/***/gBth:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"f",(function(){return i})),
/* harmony export (binding) */n.d(e,"o",(function(){return r})),
/* harmony export (binding) */n.d(e,"h",(function(){return o})),
/* harmony export (binding) */n.d(e,"d",(function(){return s})),
/* harmony export (binding) */n.d(e,"e",(function(){return c})),
/* harmony export (binding) */n.d(e,"a",(function(){return a})),
/* harmony export (binding) */n.d(e,"m",(function(){return u})),
/* harmony export (binding) */n.d(e,"l",(function(){return d})),
/* harmony export (binding) */n.d(e,"g",(function(){return l})),
/* harmony export (binding) */n.d(e,"c",(function(){return E})),
/* harmony export (binding) */n.d(e,"b",(function(){return _})),
/* harmony export (binding) */n.d(e,"n",(function(){return T})),
/* harmony export (binding) */n.d(e,"i",(function(){return f})),
/* harmony export (binding) */n.d(e,"j",(function(){return p})),
/* harmony export (binding) */n.d(e,"k",(function(){return h})),
/* harmony export (binding) */n.d(e,"w",(function(){return S})),
/* harmony export (binding) */n.d(e,"r",(function(){return I})),
/* harmony export (binding) */n.d(e,"q",(function(){return C})),
/* harmony export (binding) */n.d(e,"s",(function(){return m})),
/* harmony export (binding) */n.d(e,"p",(function(){return R})),
/* unused harmony export setKitSelectedMaintenanceInstruments */
/* unused harmony export setKitQuickCreationForm */
/* unused harmony export setKitQuickCreationFormPrioritiesLst */
/* unused harmony export setKitEditCopyFormPrioritiesList */
/* unused harmony export setQuickEditCopyForm */
/* harmony export (binding) */n.d(e,"x",(function(){return A})),
/* harmony export (binding) */n.d(e,"t",(function(){return O})),
/* harmony export (binding) */n.d(e,"y",(function(){return D})),
/* harmony export (binding) */n.d(e,"u",(function(){return N})),
/* harmony export (binding) */n.d(e,"v",(function(){return b}));const i="SET_KIT_STATUS_LIST",r="SET_SERIALKIT_LIST",o="SET_SELECTED_KIT",s="SET_KIT_COMPONENT_LIST",c="SET_KIT_SELECTED_MAINTENANCE_INSTRUMENTS",a="QUICK_CREATION_KIT_FORM_FIELD_CHANGED",u="SET_SERIALKIT_IMAGE_PRODUCT",d="SET_SERIALKIT_IMAGES_LIST_BARCODE",l="SET_QUICK_CREATION_KIT_FORM_PRIORITIES_LIST",E="SET_EDIT_COPY_KIT_FORM_PRIORITIES_LIST",_="QUICK_EDIT_COPY_KIT_FORM_FIELD_CHANGED",T="SET_SERIALKIT_LAST_PROCESS_SELECTED_KIT_STATUS_HISTORY",f="SET_SERIALKIT_ACTIVE_GRID_FILTERS",p="SET_SERIALKIT_ACTIVE_GRID_PAGE",h="SET_SERIALKIT_CALLER",S=t=>({type:h,caller:t}),I=t=>({type:i,kitStatusList:t}),C=t=>({type:r,kitList:t}),m=t=>({type:o,selectedKit:t}),R=t=>({type:s,kitComponentList:t}),A=t=>({type:u,productImageList:t}),O=t=>({type:d,imagesListBarcode:t}),D=t=>({type:T,kitStatusHistory:t}),N=t=>({type:f,filters:t}),b=t=>({type:p,page:t})},
/***/gE7A:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"c",(function(){return r})),
/* harmony export (binding) */n.d(e,"d",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"h",(function(){return c})),
/* harmony export (binding) */n.d(e,"g",(function(){return a})),
/* harmony export (binding) */n.d(e,"e",(function(){return u})),
/* harmony export (binding) */n.d(e,"f",(function(){return d})),
/* harmony export (binding) */n.d(e,"i",(function(){return l})),
/* harmony export (binding) */n.d(e,"j",(function(){return E})),
/* harmony export (binding) */n.d(e,"k",(function(){return _})),
/* harmony export (binding) */n.d(e,"o",(function(){return T})),
/* harmony export (binding) */n.d(e,"p",(function(){return f})),
/* harmony export (binding) */n.d(e,"n",(function(){return p})),
/* harmony export (binding) */n.d(e,"l",(function(){return h})),
/* harmony export (binding) */n.d(e,"m",(function(){return S}));const i="SET_EMPLOYEE_ACTIVE_GRID_FILTERS",r="SET_EMPLOYEE_ACTIVE_GRID_PAGE",o="SET_EMPLOYEE_ACTIVE_GRID_TOT_RES",s="RELOAD_INFOS_FLAG",c="SET_LABEL_ID",a="SET_EMPLOYEE_SELECTED_TAB",u="SET_EMPLOYEE_CALLER",d="SET_EMPLOYEE_INFO",l=t=>({type:i,filters:t}),E=t=>({type:r,page:t}),_=t=>({type:o,totRes:t}),T=t=>({type:c,label:t}),f=t=>({type:s,flag:t}),p=t=>({type:a,tab:t}),h=t=>({type:u,caller:t}),S=t=>({type:d,info:t})
/***/},
/***/jrL5:
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz"),r=n("afDP"),o=n("zKOZ");
/* harmony import */
// This element is *not* connected to the Redux store.
class s extends i.b{static get styles(){return[r.Db]}static get properties(){return{classesList:{type:String},cornerClassesList:{type:String},width:{type:String},tooltipText:{type:String},useDefaultClasses:{type:Boolean},showCorner:{type:Boolean},_show:{type:Boolean},mode:{type:String},enabledEvents:{type:Array},stylesString:{type:String}}}constructor(){super(),this._defaultClasses="absolute bottom-0 left-0",this._show=!1,this.classesList="",this.useDefaultClasses=!1,this.width="100px",this.defaultCornerClassesList="absolute",this.cornerClassesList="",this.enabledEvents=["over","leave"],this.stylesString=""}firstUpdated(){switch(this.mode){case"left":this.cornerClassesList+=" right-0 top-0 border-r-2 border-t-2 ",this.classesList+=" absolute right-0 top-0 rounded-l-lg rounded-b-lg rounded-t-lg ";break;case"right":this.cornerClassesList+=" left-0 top-0 border-l-2 border-t-2 ",this.classesList+=" absolute left-0 top-0 rounded-r-lg rounded-b-lg rounded-t-lg ";break;case"top-center":this.cornerClassesList+=" left-0 top-0 right-0 border-l-2 border-t-2 ",this.classesList+=" absolute left-0 top-0 right-0 "}}render(){return i.d`
      <div
        class="absolute cursor-pointer"
        @mouseover="${()=>this._display("over",!0)}"
        @click="${()=>this._display("click",!this._show)}}"
        @mouseleave="${()=>this._display("leave",!1)}}"
      >
        <div>
          <slot class="pointer" name="content"></slot>
        </div>
        ${this._show?i.d` <div style="z-index: 10000;" class="corner ${this.defaultCornerClassesList} ${this.cornerClassesList}"></div>
              <div style="z-index: 9999; width: ${this.width}; ${this.stylesString}" id="tooltip-container" class="${this.classesList}">
                <span>${Object(o.a)(this.tooltipText)}</span>
              </div>`:""}
      </div>
    `}_getWidth(){return this.width||"100px"}_display(t,e){this.enabledEvents.includes(t)&&(this._show=e)}}window.customElements.define("six-tooltip-content",s)},
/***/kFP5:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"i",(function(){return a})),
/* unused harmony export setCustomerDestinationSelectedOrder */
/* harmony export (binding) */n.d(e,"g",(function(){return u})),
/* harmony export (binding) */n.d(e,"f",(function(){return d})),
/* harmony export (binding) */n.d(e,"h",(function(){return l}));const i="SET_CUSTOMER_DESTINATION_LIST",r="SET_CUSTOMER_DESTINATION_SELECTED_ORDER",o="SET_CUSTOMER_DESTINATION_ACTIVE_PAGE",s="SET_CUSTOMER_DESTINATION_ACTIVE_FILTERS",c="SET_CUSTOMER_DESTINATION_CALLER",a=t=>({type:i,customerDestinationList:t}),u=t=>({type:o,page:t}),d=t=>({type:s,activeFilters:t}),l=t=>({type:c,caller:t})
/***/},
/***/kkVN:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"f",(function(){return i})),
/* harmony export (binding) */n.d(e,"g",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"d",(function(){return a})),
/* harmony export (binding) */n.d(e,"e",(function(){return u})),
/* harmony export (binding) */n.d(e,"m",(function(){return d})),
/* harmony export (binding) */n.d(e,"n",(function(){return l})),
/* harmony export (binding) */n.d(e,"l",(function(){return E})),
/* harmony export (binding) */n.d(e,"k",(function(){return _})),
/* harmony export (binding) */n.d(e,"h",(function(){return T})),
/* harmony export (binding) */n.d(e,"i",(function(){return f})),
/* harmony export (binding) */n.d(e,"j",(function(){return p}));const i="SET_DDT_LIST",r="SET_DDT_SELECTED_ORDER",o="SET_DDT_ACTIVE_PAGE",s="SET_DDT_ACTIVE_GRID_FILTERS",c="SET_DDT_CALLER",a="SET_DDT_IDS_LANDING",u="SET_DDT_LANDING_CALLER",d=t=>({type:i,ddtList:t}),l=t=>({type:r,ddtSelectedOrder:t}),E=t=>({type:o,page:t}),_=t=>({type:s,filters:t}),T=t=>({type:c,caller:t}),f=t=>({type:a,ids:t}),p=t=>({type:u,landingCaller:t})
/***/},
/***/kxRW:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));
/* unused harmony export setKitsCountByArea */
/* unused harmony export setSelectedORderList */
const i="DW_SET_KITS_COUNT_BY_AREA",r="DW_SET_SELECTED_ORDER_LIST"},
/***/lMlU:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"a",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"i",(function(){return a})),
/* unused harmony export setCustomerSelectedOrder */
/* harmony export (binding) */n.d(e,"g",(function(){return u})),
/* harmony export (binding) */n.d(e,"f",(function(){return d})),
/* harmony export (binding) */n.d(e,"h",(function(){return l}));const i="SET_CUSTOMER_LIST",r="SET_CUSTOMER_SELECTED_ORDER",o="SET_CUSTOMER_ACTIVE_PAGE",s="SET_CUSTOMER_ACTIVE_FILTERS",c="SET_CUSTOMER_CALLER",a=t=>({type:i,customerList:t}),u=t=>({type:o,page:t}),d=t=>({type:s,activeFilters:t}),l=t=>({type:c,caller:t})},
/***/nQzK:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));const i="SET_MATCH_GARMENT_EMPLOYEE_ACTIVE_GRID_FILTERS",r=t=>({type:i,filters:t})},
/***/oUcY:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"h",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o})),
/* harmony export (binding) */n.d(e,"f",(function(){return s})),
/* harmony export (binding) */n.d(e,"g",(function(){return c})),
/* harmony export (binding) */n.d(e,"d",(function(){return a})),
/* harmony export (binding) */n.d(e,"a",(function(){return u})),
/* harmony export (binding) */n.d(e,"b",(function(){return d}));
/* unused harmony export setLifesaverLevel */
/* unused harmony export setSerialKitSorting */
/* unused harmony export setOrderSorting */
/* unused harmony export setOrdersList */
/* unused harmony export setSerialKitList */
/* unused harmony export setSerialKitPriority */
/* unused harmony export setOrderPriority */
/* unused harmony export setAreaList */
const i="SET_TIMEBOARD_SERIAL_KIT_SORTING",r="SET_TIMEBOARD_ORDER_SORTING",o="SET_TIMEBOARD_ORDERS_LIST",s="SET_TIMEBOARD_SERIAL_KIT_LIST",c="SET_TIMEBOARD_SERIAL_KIT_PRIORITY",a="SET_TIMEBOARD_ORDER_PRIORITY",u="SET_TIMEBOARD_AREA_LIST",d="SET_TIMEBOARD_LIFESAVER_LEVEL"},
/***/peiT:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"f",(function(){return i})),
/* harmony export (binding) */n.d(e,"i",(function(){return r})),
/* harmony export (binding) */n.d(e,"h",(function(){return o})),
/* harmony export (binding) */n.d(e,"g",(function(){return s})),
/* harmony export (binding) */n.d(e,"e",(function(){return c})),
/* harmony export (binding) */n.d(e,"c",(function(){return a})),
/* harmony export (binding) */n.d(e,"b",(function(){return u})),
/* harmony export (binding) */n.d(e,"a",(function(){return d})),
/* harmony export (binding) */n.d(e,"d",(function(){return l})),
/* harmony export (binding) */n.d(e,"o",(function(){return E})),
/* unused harmony export setProductStatusList */
/* harmony export (binding) */n.d(e,"p",(function(){return _})),
/* harmony export (binding) */n.d(e,"q",(function(){return T})),
/* harmony export (binding) */n.d(e,"n",(function(){return f})),
/* harmony export (binding) */n.d(e,"l",(function(){return p})),
/* harmony export (binding) */n.d(e,"k",(function(){return h})),
/* harmony export (binding) */n.d(e,"j",(function(){return S})),
/* harmony export (binding) */n.d(e,"m",(function(){return I}));const i="SET_PRODUCT_LIST",r="SET_PRODUCT_STATUS_LIST",o="SET_PRODUCT_SELECTED_PRODUCT",s="SET_PRODUCT_SELECTED_KIT_COMPONENTS",c="SET_PRODUCT_IMAGE_LIST",a="SET_PRODUCT_ATTACHMENTS_LIST",u="SET_PRODUCT_ACTIVE_GRID_PAGE",d="SET_PRODUCT_ACTIVE_GRID_FILTERS",l="SET_PRODUCT_CALLER",E=t=>({type:i,productList:t}),_=t=>({type:o,productSelected:t}),T=t=>({type:s,productSelectedKitComponents:t}),f=t=>({type:c,productImageList:t}),p=t=>({type:a,productAttachmentsList:t}),h=t=>({type:u,page:t}),S=t=>({type:d,filters:t}),I=t=>({type:l,caller:t})},
/***/qUps:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"i",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"h",(function(){return o})),
/* harmony export (binding) */n.d(e,"g",(function(){return s})),
/* harmony export (binding) */n.d(e,"c",(function(){return c})),
/* harmony export (binding) */n.d(e,"e",(function(){return a})),
/* harmony export (binding) */n.d(e,"b",(function(){return u})),
/* harmony export (binding) */n.d(e,"f",(function(){return d})),
/* harmony export (binding) */n.d(e,"d",(function(){return l})),
/* harmony export (binding) */n.d(e,"q",(function(){return E})),
/* harmony export (binding) */n.d(e,"j",(function(){return _})),
/* harmony export (binding) */n.d(e,"r",(function(){return T})),
/* harmony export (binding) */n.d(e,"p",(function(){return f})),
/* harmony export (binding) */n.d(e,"l",(function(){return p})),
/* harmony export (binding) */n.d(e,"n",(function(){return h})),
/* harmony export (binding) */n.d(e,"m",(function(){return S})),
/* harmony export (binding) */n.d(e,"k",(function(){return I})),
/* harmony export (binding) */n.d(e,"o",(function(){return C}));const i="SET_AUTORDERCONFIRMATION_ORDERS_STER",r="SET_AUTOORDERCONFIRMATION_ELEMENTS_LOADED_STER",o="SET_AUTOORDERCONFIRMATION_SELECTED_ORDER_STER",s="SET_AUTOORDERCONFIRMATION_NOT_COMPLIANT_REASONS",c="SET_AUTOORDERCONFIRMATION_INTEGRATION_CYCLE",a="SET_AUTOORDERCONFIRMATION_INTEGRATION_WARNING",u="SET_AUTOORDERCONFIRMATION_INTEGRATION_ACTIVE",d="SET_AUTOORDERCONFIRMATION_LIVE_REPORT_URL",l="SET_AUTOORDERCONFIRMATION_INTEGRATION_SUSPENDED",E=t=>({type:i,orders:t}),_=t=>({type:r,elementsLoaded:t}),T=t=>({type:o,selectedOrder:t}),f=t=>({type:s,notCompliantReasonList:t}),p=t=>({type:c,payload:t}),h=t=>({type:a,warning:t}),S=t=>({type:l,suspended:t}),I=t=>({type:u,active:t}),C=t=>({type:d,url:t})},
/***/r8Sg:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i}));
/* unused harmony export setPackFiltersAction */
const i="SET_PACK_FILTERS"},
/***/ri9B:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"h",(function(){return i})),
/* harmony export (binding) */n.d(e,"f",(function(){return r})),
/* harmony export (binding) */n.d(e,"m",(function(){return o})),
/* harmony export (binding) */n.d(e,"l",(function(){return s})),
/* harmony export (binding) */n.d(e,"n",(function(){return c})),
/* harmony export (binding) */n.d(e,"e",(function(){return a})),
/* harmony export (binding) */n.d(e,"o",(function(){return u})),
/* harmony export (binding) */n.d(e,"a",(function(){return d})),
/* harmony export (binding) */n.d(e,"p",(function(){return l})),
/* harmony export (binding) */n.d(e,"b",(function(){return E})),
/* harmony export (binding) */n.d(e,"k",(function(){return _})),
/* harmony export (binding) */n.d(e,"i",(function(){return T})),
/* harmony export (binding) */n.d(e,"j",(function(){return f})),
/* harmony export (binding) */n.d(e,"c",(function(){return p})),
/* harmony export (binding) */n.d(e,"d",(function(){return h})),
/* harmony export (binding) */n.d(e,"s",(function(){return S})),
/* harmony export (binding) */n.d(e,"u",(function(){return I})),
/* harmony export (binding) */n.d(e,"t",(function(){return C})),
/* harmony export (binding) */n.d(e,"q",(function(){return m})),
/* harmony export (binding) */n.d(e,"r",(function(){return R})),
/* harmony export (binding) */n.d(e,"g",(function(){return A})),
/* harmony export (binding) */n.d(e,"D",(function(){return O})),
/* harmony export (binding) */n.d(e,"B",(function(){return D})),
/* unused harmony export setShipmentSelectedKit */
/* harmony export (binding) */n.d(e,"G",(function(){return N})),
/* harmony export (binding) */n.d(e,"H",(function(){return b})),
/* harmony export (binding) */n.d(e,"A",(function(){return L})),
/* unused harmony export setShipmentSupplier */
/* harmony export (binding) */n.d(e,"I",(function(){return g})),
/* harmony export (binding) */n.d(e,"v",(function(){return v})),
/* harmony export (binding) */n.d(e,"w",(function(){return y})),
/* harmony export (binding) */n.d(e,"y",(function(){return P})),
/* harmony export (binding) */n.d(e,"E",(function(){return k})),
/* harmony export (binding) */n.d(e,"F",(function(){return w})),
/* harmony export (binding) */n.d(e,"K",(function(){return M})),
/* harmony export (binding) */n.d(e,"x",(function(){return x})),
/* harmony export (binding) */n.d(e,"C",(function(){return G})),
/* harmony export (binding) */n.d(e,"z",(function(){return K})),
/* harmony export (binding) */n.d(e,"J",(function(){return U}));const i="SET_SHIPMENT_KIT_LIST",r="SET_SHIPMENT_DESTINATION_LIST",o="SET_SHIPMENT_SELECTED_KIT",s="SET_SHIPMENT_SELECTED_DESTINATION",c="SET_SHIPMENT_SHIPPING_LIST",a="SET_SHIPMENT_DDT_DRAFT",u="SET_SHIPMENT_SUPPLIER",d="CREATE_SHIPMENT_TYPE",l="SET_SHIPMENT_TYPE",E="SET_CALLER",_="SET_SHIPMENT_ORDER_ID",T="SET_SHIPMENT_ORDER_GROUP_PIANA",f="SET_SHIPMENT_ORDER_GROUP_VEST_PACCHI",p="SET_LAST_SEARCH",h="SET_SHIPMENT_ACTIVE_GRID_FILTERS",S="CUSTOMER",I="SUPPLIER",C="CUSTRETURN",m="SET_SHIPMENT_WARDROBE_CODE",R="SET_SHIPMENT_WARD_LM_PACK_ACTIVE_GRID_FILTERS",A="SET_SHIPMENT_FILTERS",O=t=>({type:i,shipmentKitList:t}),D=t=>({type:r,shipmentDestinationList:t}),N=t=>({type:s,shipmentSelectedDestination:t}),b=t=>({type:c,shippingList:t}),L=t=>({type:a,ddtDraft:t}),g=t=>({type:l,shipmentType:t}),v=t=>({type:d,shipmentType:t}),y=t=>({type:E,caller:t}),P=t=>({type:_,orderId:t}),k=t=>({type:T,orderGroupPiana:t}),w=t=>({type:f,orderGroupVestPacchi:t}),M=t=>({type:m,wardrobeCode:t}),x=t=>({type:p,lastSearch:t}),G=t=>({type:A,shipmentFilters:t}),K=t=>({type:h,filters:t}),U=t=>({type:R,filtersShipmentLmPack:t})},
/***/rxEq:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o})),
/* harmony export (binding) */n.d(e,"d",(function(){return s})),
/* unused harmony export setElementGridAssociations */
/* unused harmony export setGridType */
/* unused harmony export setIsCodeGridManagement */
/* harmony export (binding) */n.d(e,"e",(function(){return c}));const i="SET_ELEMENT_GRID_ASSOCIATIONS",r="SET_GRID_TYPE",o="SET_IS_CODE_GRID_MANAGEMENT",s="SET_PROCESSED_LIST",c=t=>({type:s,processedList:t})},
/***/tki3:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"c",(function(){return r})),
/* harmony export (binding) */n.d(e,"i",(function(){return o})),
/* harmony export (binding) */n.d(e,"d",(function(){return s})),
/* harmony export (binding) */n.d(e,"e",(function(){return c})),
/* harmony export (binding) */n.d(e,"a",(function(){return a})),
/* harmony export (binding) */n.d(e,"h",(function(){return u})),
/* harmony export (binding) */n.d(e,"g",(function(){return d})),
/* harmony export (binding) */n.d(e,"f",(function(){return l})),
/* harmony export (binding) */n.d(e,"k",(function(){return E})),
/* unused harmony export setCycleArchiveMachineList */
/* harmony export (binding) */n.d(e,"q",(function(){return _})),
/* harmony export (binding) */n.d(e,"l",(function(){return T})),
/* harmony export (binding) */n.d(e,"m",(function(){return f})),
/* harmony export (binding) */n.d(e,"j",(function(){return p})),
/* harmony export (binding) */n.d(e,"p",(function(){return h})),
/* harmony export (binding) */n.d(e,"o",(function(){return S})),
/* harmony export (binding) */n.d(e,"n",(function(){return I}));const i="SET_CYCLEARCHIVE_CYCLE_LIST",r="SET_CYCLEARCHIVE_MACHINE_LIST",o="SET_CYCLEARCHIVE_SELECTED_MACHINE",s="SET_CYCLEARCHIVE_NEW_TEST_CYCLE",c="SET_CYCLEARCHIVE_SELECTED_CYCLE",a="SET_CYCLEARCHIVE_ACTIVE_TAB",u="SET_CYCLEARCHIVE_SELECTED_EQUIPMENT_ACTION",d="SET_CYCLEARCHIVE_SELECTED_EQUIPMENT_IS_INTEGRATED",l="SET_CYCLEARCHIVE_EQUIPMENT_INTEGRATION_SUSPENDED",E=t=>({type:i,cycleList:t}),_=t=>({type:o,selectedMachine:t}),T=t=>({type:s,newTestCycle:t}),f=t=>({type:c,selectedCycle:t}),p=t=>({type:a,activeTab:t}),h=t=>({type:u,status:t}),S=t=>({type:d,isIntegrated:t}),I=t=>({type:l,isSuspended:t})
/***/},
/***/uvzX:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r})),
/* harmony export (binding) */n.d(e,"d",(function(){return o})),
/* harmony export (binding) */n.d(e,"c",(function(){return s}));const i="SET_CALLER",r="SET_COMPONENT_ACTIVE_GRID_FILTERS",o=t=>({type:i,caller:t}),s=t=>({type:r,filters:t})},
/***/vBTZ:
/***/function(t,e,n){"use strict";
/* harmony import */var i=n("Rukz");class r extends i.b{static get styles(){return[]}static get properties(){return{value:{type:String,reflect:!0},
// Read code (unicode, barcode or badge)
read:{type:Object,reflect:!0},
// Read received from websocket (as object like {"type":"R","read":"300ED89F3350004000393825","ts":1548410055603} ).
auto:{type:Boolean},
// If true, opens connection at ready event.
url:{type:String},
// Web-socket url (eg. ws://docker0.ict-group.it:8666/clients/WS-01).
milliseconds:{type:Boolean}}}render(){return i.d` <div></div> `}constructor(){super(),this.auto=!1,this.milliseconds=!1}disconnectedCallback(){this.closeWebsocket()}updated(t){t.has("url")&&this.url&&this.auto&&(this.closeWebsocket(),this.openWebsocket())}
/****************************************************************** */keepAlive(){this._websocket&&(!this._websocket.readyState==this._websocket.OPEN?console.log("Connection NOT opened with websocket "+this.url):this._websocket.send('{"code":"_all"}'))}openWebsocket(){if(!this.url)throw Error("url property is required");this._websocket=new WebSocket(this.url,this.protocols),this._websocket.onopen=this._onOpen.bind(this),this._websocket.onclose=this._onClose.bind(this),this._websocket.onmessage=this._onMessage.bind(this),this._websocket.onerror=this._onError.bind(this)}closeWebsocket(){this._websocket&&(this._stopReconnectionInterval(),this._skipReconnection=!0,this._websocket.close(),this._websocket=null)}reconnectWebSocket(){this.closeWebsocket(),this.openWebsocket()}_onOpen(){console.log("Connection opened with websocket "+this.url),this._statusNotify("OPEN")}_onClose(){console.log("Connection closed with websocket "+this.url),this._websocket=null,this._statusNotify("CLOSED"),this._startReconnectionInterval()}_onError(){console.log("connection error"),this._websocket=null,this._statusNotify("ERROR")}_startReconnectionInterval(){this._reconnectionInterval||(this._skipReconnection?this._stopReconnectionInterval():this._reconnectionInterval=setInterval(()=>{this.url&&!this._websocket?(console.log("reconnection interval: openWebsocket"),this.openWebsocket()):(console.log("reconnection interval: end"),this._stopReconnectionInterval())},5e3))}_stopReconnectionInterval(){this._skipReconnection=null,this._reconnectionInterval&&(clearInterval(this._reconnectionInterval),this._reconnectionInterval=null)}_onMessage(t){let e=JSON.parse(t.data);for(let t of e.reads)this.value=t.read,this.milliseconds||(t.ts=new Date(t.ts)),this.read=t,this._notify()}
/**
   * Read event broadcast.
   */_notify(){this.dispatchEvent(new CustomEvent("websocket-message",{detail:{value:this.value,read:this.read}}))}_statusNotify(t){this.dispatchEvent(new CustomEvent("status-notify",{detail:{status:t}}))}}window.customElements.define("six-websocket-listener",r)},
/***/vcFs:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"d",(function(){return i})),
/* harmony export (binding) */n.d(e,"a",(function(){return r})),
/* harmony export (binding) */n.d(e,"b",(function(){return o})),
/* harmony export (binding) */n.d(e,"c",(function(){return s}));
// inizializzate a build-time da webpack, private.
// eslint-disable-next-line no-undef
const i=!0,r="sixlm",o="sixlm",s={};// eslint-disable-next-line no-undef
},
/***/xD8C:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"b",(function(){return i})),
/* harmony export (binding) */n.d(e,"e",(function(){return r})),
/* harmony export (binding) */n.d(e,"c",(function(){return o})),
/* harmony export (binding) */n.d(e,"d",(function(){return s})),
/* harmony export (binding) */n.d(e,"a",(function(){return c})),
/* harmony export (binding) */n.d(e,"g",(function(){return a})),
/* harmony export (binding) */n.d(e,"j",(function(){return u})),
/* harmony export (binding) */n.d(e,"h",(function(){return d})),
/* harmony export (binding) */n.d(e,"f",(function(){return l})),
/* harmony export (binding) */n.d(e,"i",(function(){return E}));const i="SET_AUTH_DATA",r="SET_WORKSTATION",o="SET_BOOKMARKS",s="SET_SYSPAR",c="LOGOUT",a=t=>({type:i,authData:t}),u=t=>({type:r,workstation:t}),d=t=>({type:o,bookmarks:t}),l=()=>({type:c}),E=t=>({type:s,sysPar:t})},
/***/yzKQ:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return r}));
/* harmony import */var i=n("jimv");function r(t="success",e,n,r,o,s="top-center",c=4e3,a,u,d,l,E){let _,T;const f=new Promise((t,e)=>{_=t,T=e}),p=Object(i.b)(`${e}.${t}`,"COMMON."+t,r,o);return document.dispatchEvent(new CustomEvent("new-sx-message",{detail:{message:{type:t,title:n,message:p,position:s,duration:c,okButton:a,cancelButton:u,okButtonText:d,cancelButtonText:l,customStyle:E},promise:{resolve:_,reject:T}}})),f}
/***/},
/***/yzxD:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return i})),
/* harmony export (binding) */n.d(e,"b",(function(){return r}));
/* unused harmony export setLoanedFiltersAction */
/* unused harmony export setLoanedPageAction */
const i="SET_LOANED_FILTERS",r="SET_LOANED_PAGE"},
/***/zbnX:
/***/function(t,e,n){"use strict";
/* harmony export (binding) */n.d(e,"a",(function(){return s}));
/* harmony import */var i=n("Rukz"),r=n("yzKQ"),o=n("jimv");
/* harmony import */class s extends i.b{constructor(){super(),
/**
     * Function to automatically trigger the requestUpdate when the controlled values are changed.
     * Only one call to this function must exist for it to work properly, and by convention
     * this must be inside the stateChanged function.
     *
     * Values are comapred using '==='.
     * Only for properties belonging to the redux store.
     * @deprecated
     * @function watchState
     * @param  {...any} values proprietà dello state che devono triggerare l'update della view all'assegnazione di un nuovo valore
     * @returns {Array<Number>} gli indici delle proprietà che sono cambiate
     */
this.watchState=function(t){let e={},n=null;return(...i)=>{let r=[],o=!1;return i.forEach((t,n)=>{e[n]!==t&&(r.push(n),o=!0),e[n]=t}),o&&(clearTimeout(n),n=setTimeout(()=>{t()},250)),r}}
/***/(this.requestUpdate.bind(this))}
/**
   * set the i18n root key for the message functions and
   * sxTranslation functions provided in the class.
   * default 'COMMON'
   * @abstract
   */getI18nBaseKey(){return"COMMON"}
/**
   * Translates a string and returns it. The string is prefixed with the value returned by the getI18nBaseKey() function.
   * Fallback on COMMON namespace if the page doesen't provide the specified key.
   * If you don't want the fallback, use translate() from six-utils
   * @param {String} string - String to translate. can be i18n key or raw string
   * @param {string[]} interpolate - Array of values to replace in the string.
   * @example
   *  sxTranslate("{0} marc, {1}", ["hello", "nice to meet you"])
   * @return {String} Tranlsation
   */sxTranslate(t,e){return Object(o.b)(this.getI18nBaseKey(),"COMMON",t,e)}
/**
   * Message options
   * @typedef {Object} MessageOption
   * @property {string} [title] - The title
   * @property {'top-stretch'|'top-start'|'top-center'|'top-end'|'middle'|'bottom-start'|'bottom-center'|'bottom-end'|'bottom-stretch'} [position='bottom-end'] - The position
   * @property {number} [duration = 4000] - The duration
   * @property {String[]} [interpolate] - Array of strings or i18n keys to replace in the message. can be mixed
   * @property {boolean} okButton - show ok action button on notification
   * @property {boolean} cancelButton - show cancel action button on notification
   * @property {string} okButtonText - ok action button label
   * @property {string} cancelButtonText - cancel action button label
   * @property {string} customStyle - custom css
   */
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */displayMessage(t,{title:e,position:n,duration:i,interpolate:o,okButton:s,cancelButton:c,okButtonText:a,cancelButtonText:u,customStyle:d}={}){return Object(r.a)("success",this.getI18nBaseKey(),e,t,o,n,i,s,c,a,u,d)}
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */errorMessage(t,{title:e,position:n,duration:i,interpolate:o,okButton:s,cancelButton:c,okButtonText:a,cancelButtonText:u,customStyle:d}={}){return Object(r.a)("error",this.getI18nBaseKey(),e,t,o,n,i,s,c,a,u,d)}
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */warnMessage(t,{title:e,position:n,duration:i,interpolate:o,okButton:s,cancelButton:c,okButtonText:a,cancelButtonText:u,customStyle:d}={}){return Object(r.a)("warning",this.getI18nBaseKey(),e,t,o,n,i,s,c,a,u,d)}
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */infoMessage(t,{title:e,position:n,duration:i,interpolate:o,okButton:s,cancelButton:c,okButtonText:a,cancelButtonText:u,customStyle:d}={}){return Object(r.a)("info",this.getI18nBaseKey(),e,t,o,n,i,s,c,a,u,d)}
/*   debounce(f, interval) {
    let timer = null;
     return (...args) => {
      clearTimeout(timer);
      return new Promise((resolve) => {
        timer = setTimeout(
          () => resolve(f(...args)),
          interval,
        );
      });
    };
  } */}}}]);